import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, Badge, Nav, NavItem, NavLink, TabContent, TabPane,  UncontrolledPopover, PopoverBody, PopoverHeader, Container
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import filterFactory, { selectFilter, multiSelectFilter, textFilter, customFilter, FILTER_TYPES  } from 'react-bootstrap-table2-filter';

import NumberFormat from 'react-number-format';

import Chart from "react-google-charts";

import { Kennzahl } from './KennzahlComp';
import { SelectSearchFilter } from './SelectSearchFilterComp';


import * as Utilities from "./Utilities"

import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import * as Tree from 'react-dropdown-tree-select'
import DropdownTreeSelect from 'react-dropdown-tree-select'

type State = {
    ready: boolean,        
    invests: KSLPlusAPI.InvestitionsModelDoppik[],
    expanded: number[];
    filter: boolean;
    filterGrenze: number|undefined;
    filterJahre: number;
}

type Props = {        
    kunde: number,
    gemeinde: number,
    jahr: number,
    plantyp: number,
    planstufe: number,    
    invests: KSLPlusAPI.InvestitionsModelDoppik[],
    investSettings: KSLPlusAPI.InvestSettingModel,
    settings: KSLPlusAPI.SettingsModel,
    uhconfig: KSLPlusAPI.UhConfigModel | undefined

}



export class InvestitionenDoppisch extends Component<Props, State> {
    constructor(props: any) {
        super(props);

    }

    node: any;
    container: any = null;


    vermoegensarten: KSLPlusAPI.VermoegensartDoppisch[] = [];
    investitionsarten: KSLPlusAPI.Investitionsarten[] = [];
    getFilters: { (filter: string | undefined): void }[] = [];
    filterVals: Record<string, any> = {};


    state: State = {
        ready: false,        
        invests: [],
        expanded: [],
        filter: false,
        filterGrenze: 0,
        filterJahre: 0
    }


    componentDidMount() {
        this.readInvestitionsarten();
    }

    addFilter2Column2 = (column: any, dataField: string, multiSelect: boolean = false, options: any[] = [], parentField: string = 'investition', parentIsArray: boolean = false, parentField2: string = '') => {
        if (options.length === 0)
            options = this.getFilterOptions2(this.state.invests, dataField);
        column.filter = customFilter({
            type: FILTER_TYPES.TEXT,
            onFilter: (filterVal: any[] | any, data: KSLPlusAPI.InvestitionsModelDoppik[]) => {
                if (filterVal?.constructor && filterVal.constructor === Array) {

                    if (this.filterVals[dataField] === null || filterVal.length === 0) { return data };
                    return data.filter(r => {
                        const p = r as unknown as { [key: string]: string };

                        if (parentIsArray) {
                            if (parentField2 !== "") {
                                const i = p[parentField] as unknown as { [key: string]: string }[];
                                return filterVal.some((val: any) => i.some(i1 => ((i1[parentField2] as unknown as { [key: string]: string })[dataField] === val.value)));
                            }
                            else {
                                const i = p[parentField] as unknown as { [key: string]: string }[];
                                return filterVal.some((val: any) => i.some(i1 => (i1[dataField] === val.value)));
                            }
                        }
                        else {
                            const i = p[parentField] as unknown as { [key: string]: string };
                            return i[dataField] !== undefined && filterVal.findIndex((val: any) => val.value === i[dataField]) !== -1;
                        }

                    }); return data;
                }
                if (this.filterVals[dataField] === null) { return data }; if (filterVal?.value !== "") return data.filter(r => {
                    const p = r as unknown as { [key: string]: string };

                    if (parentIsArray) {
                        if (parentField2 !== "") {
                            const i = p[parentField] as unknown as { [key: string]: string }[];
                            return i.some(i1 => (i1[parentField2] as unknown as { [key: string]: string })[dataField] === filterVal?.value);                        
                        }
                        else {
                            const i = p[parentField] as unknown as { [key: string]: string }[];
                            return i.some(i1 => i1[dataField] === filterVal?.value);                        
                        }
                    }
                    else {
                        const i = p[parentField] as unknown as { [key: string]: string };
                        return i[dataField] !== undefined && i[dataField] === filterVal?.value;
                    }
                        
                }); return data;
            }
        });
        column.filterRenderer = (onFilter: any, column: any) => {
            return <SelectSearchFilter multiSelect={multiSelect} selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter); }} column={column} filterOptions={options} />
        }
    }
    

    addFilter2Column = (column: any, dataField: string, multiSelect: boolean = false, options: Tree.TreeNode[] = [], parentField: string = 'investition', parentIsArray: boolean = false, parentField2: string = '', fieldIsArray: boolean = false) => {
        if (options.length === 0)
            options = this.getFilterOptions2(this.state.invests, dataField);
        column.filter = customFilter({
            type: FILTER_TYPES.TEXT,
            onFilter: (filterVal: any[] | any, data: KSLPlusAPI.InvestitionsModelDoppik[]) => {
                if (filterVal?.constructor && filterVal.constructor === Array) {

                    if (this.filterVals[dataField] === null || filterVal.length === 0) { return data };
                    return data.filter(r => {
                        const p = r as unknown as { [key: string]: string };

                        if (parentIsArray) {
                            if (fieldIsArray) {
                                if (parentField2 !== "") {
                                    const i = p[parentField] as unknown as { [key: string]: string }[];
                                    return filterVal.some((val: any) => i.some(i1 => ((i1[parentField2] as unknown as { [key: string]: string[] })[dataField].toString() === val.value)));
                                }
                                else {
                                    const i = p[parentField] as unknown as { [key: string]: string[] }[];
                                    return filterVal.some((val: any) => i.some(i1 => i1[dataField].some(s => s === val.value)));
                                }
                            }
                            else {
                                if (parentField2 !== "") {
                                    const i = p[parentField] as unknown as { [key: string]: string }[];
                                    return filterVal.some((val: any) => i.some(i1 => ((i1[parentField2] as unknown as { [key: string]: string })[dataField].toString() === val.value)));
                                }
                                else {
                                    const i = p[parentField] as unknown as { [key: string]: string }[];
                                    return filterVal.some((val: any) => i.some(i1 => (i1[dataField].toString() === val.value)));
                                }
                            }
                        }
                        else {
                            if (fieldIsArray) {
                                const i = p[parentField] as unknown as { [key: string]: string[] };                                
                                return i[dataField] !== undefined && filterVal.some((val: any) => i[dataField].some( s => s === val.value ));
                            }
                            else {
                                const i = p[parentField] as unknown as { [key: string]: string };
                                return i[dataField] !== undefined && filterVal.some((val: any) => val.value === i[dataField].toString());
                            }
                        }

                    }); return data;
                }
                if (this.filterVals[dataField] === null) { return data }; if (filterVal?.value !== "") return data.filter(r => {
                    const p = r as unknown as { [key: string]: string };

                    if (parentIsArray) {
                        if (parentField2 !== "") {
                            const i = p[parentField] as unknown as { [key: string]: string }[];
                            return i.some(i1 => (i1[parentField2] as unknown as { [key: string]: string })[dataField].toString() === filterVal?.value);
                        }
                        else {
                            const i = p[parentField] as unknown as { [key: string]: string }[];
                            return i.some(i1 => i1[dataField].toString() === filterVal?.value);
                        }
                    }
                    else {
                        const i = p[parentField] as unknown as { [key: string]: string };
                        return i[dataField] !== undefined && i[dataField].toString() === filterVal?.value;
                    }

                }); return data;
            }
        });
        //column.filterRenderer = (onFilter: any, column: any) => {
          //  return <SelectSearchFilter multiSelect={multiSelect} selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter); }} column={column} filterOptions={options} />
        //}
        column.filterRenderer = (onFilter: any, column: any) => {
            return <DropdownTreeSelect className="kslplus-invest-treeselect" data={options} inlineSearchInput={false} mode={"multiSelect"} texts={{ placeholder: "Filter", noMatches: "Kein Treffer" }}  keepTreeOnSearch={true} onChange={(data: Tree.TreeNode, selected: Tree.TreeNode[]) => this.handleTreeClick(data, selected, dataField, onFilter)} />            
            //return <SelectSearchFilter multiSelect={multiSelect} selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter); }} column={column} filterOptions={options} />
        }
        
    }

    handleTreeClick = (data: Tree.TreeNode, selected: Tree.TreeNode[], dataField: string, onFilter: any) => {        
        if (data.tagLabel === null) {
            selected = [];
            data.checked = false;
            data.disabled = true;            
            this.setState({ ready: true });    
        }   
        
        this.filterVals[dataField] = selected;
        onFilter(selected);

    }

    createColumns = (invests: KSLPlusAPI.InvestitionsModelDoppik[], spalten: string) => {
        var columns: any[] = [];

        if (!this.props.settings.hhStellenOeffentlich) {
            columns.push({
                dataField: 'df1',
                text: "",
                isDummyField: true,
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "30px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "30px" };
                }
            });
        }

        var c: any = {
            dataField: 'investition.bezeichnung',
            bez: "Bezeichnung",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Bezeichnung'] ?? "Bezeichnung Maßnahme"): "Bezeichnung Maßnahme",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "230px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "230px" };
            },
            /*
            filter: selectFilter(
                        {   options: this.getFilterOptions(this.state.invests, "bezeichnung"), 
                            placeholder: "Alle", 
                            className: "kslplus-tabellen-multiselect", 
                            style: { width: "220px" },
                            getFilter: (filter:any) => {                                    
                                this.getFilters.push(filter);                                    
                            } } ),                                

            */            
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                const ve = (this.props.investSettings.veimmer === undefined || this.props.investSettings.veimmer) || (row.investition !== undefined && row.investition.veGesamt !== undefined && row.investition.veGesamt > 0);
                const ga = (this.props.investSettings.gaimmer === undefined || this.props.investSettings.gaimmer) || (row.investition && row.investition.gesamtbedarf !== undefined && row.investition.gesamtzuwendungen !== undefined && row.investition.bisherVereinnahmt !== undefined && row.investition.bisherVerausgabt !== undefined ? Math.abs(row.investition.gesamtbedarf) /*+ Math.abs(row.investition.gesamtzuwendungen) + Math.abs(row.investition.bisherVereinnahmt) + Math.abs(row.investition.bisherVerausgabt)*/ > 0 : false);
                var beschreibungen = this.createBeschreibungsItems(row.texte, ve, ga);
                var werte = this.createWerteItems(row, ve, ga);
                return (
                    <div>
                        <div className="kslplus-tabellen-bezeichnung">{row.investition && row.investition.bezeichnung ? row.investition.bezeichnung : ""}</div>
                        {werte.length > 0 || beschreibungen.length > 0 ? <Badge className="kslplus-info-badge " id={row.investition && row.investition.id ? "kslplus-info-text-" + row.investition.id : ""}>i</Badge> : null}
                        {werte.length > 0 || beschreibungen.length > 0 ?
                            <UncontrolledPopover
                                size="lg"
                                placement="right"
                                target={row.investition && row.investition.id ? "kslplus-info-text-" + row.investition.id : ""}
                                trigger="hover"
                                className="kslplus-invest-popover">
                                <PopoverBody className="kslplus-invest-popover-body">
                                    <Container className={(this.props.investSettings.veimmer === undefined || this.props.investSettings.veimmer) || (row.investition !== undefined && row.investition.veGesamt !== undefined && row.investition.veGesamt > 0) ? "kslplus-invest-popover-block" : "kslplus-invest-popover-block-small"}>
                                        <div className="kslplus-invest-popover-container-beschreibungen">
                                            {beschreibungen}
                                        </div>
                                        <div className="kslplus-invest-popover-container-werte">
                                            {werte}
                                        </div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover> : null
                        }
                    </div>

                );
            },
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }


        };

        this.addFilter2Column(c, 'bezeichnung');
        columns.push(c);

        c = {
            dataField: 'investition.plz',            
            bez: "PLZ",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['PLZ'] ?? "PLZ") : "PLZ",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "100px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "100px" };
            },
            /*
            filter: selectFilter({ 
                options: this.getFilterOptions(this.state.invests, "plz"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "85px" },
                getFilter: (filter:any) => { this.getFilters.push(filter) }
            }),
            filter: customFilter({
                type: FILTER_TYPES.TEXT,
                onFilter: (filterVal: string | undefined, data: KSLPlusAPI.InvestitionsModelDoppik[]) => {
                    if (this.filterVals[dataField] === null) { return data }; if (filterVal && filterVal !== "") return data.filter(r => {
                        const i = r.investition as unknown as { [key: string]: string };
                        return i[dataField] && i[dataField].toLowerCase() === (filterVal?.toLowerCase() ?? "")
                    }); return data;
                }
            }),
            filterRenderer: (onFilter: any, column: any) => {                    
                return <SelectSearchFilter id={dataField} selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter?.value); }} column={column} filterOptions={this.getFilterOptions(this.state.invests, column.dataField)} />
            },*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }

        };

        this.addFilter2Column2(c, 'plz');
        columns.push(c);


        c = {
            dataField: 'investition.ort',            
            bez: "Ort",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Ort'] ?? "Ort") : "Ort",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            /*
            filter: selectFilter({ 
                options: this.getFilterOptions(this.state.invests, "ort"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "135px" },
                getFilter: (filter:any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }

        };
        this.addFilter2Column2(c, 'ort');
        columns.push(c);

        c = {
            dataField: 'investition.ortsteil',            
            bez: "Ortsteil",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Ortsteil'] ?? "Ortsteil") : "Ortsteil",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            /*
            filter: selectFilter({ 
                options: this.getFilterOptions(this.state.invests, "ortsteil"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "135px" },
                getFilter: (filter:any) => { this.getFilters.push(filter) }
            }),*/


            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
        };
        this.addFilter2Column2(c, 'ortsteil');
        columns.push(c);

        c = {
            dataField: 'investition.strasse',            
            bez: "Straße",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Straße'] ?? "Strasse") : "Strasse",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            
            /*
            filter: selectFilter({ 
                options: this.getFilterOptions(this.state.invests, "strasse"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "135px" },
                getFilter: (filter:any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
        };
        this.addFilter2Column2(c, 'strasse');
        columns.push(c);

        c = {
            dataField: 'investition.hausnummer',            
            bez: "Hausnr.",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Hausnr.'] ?? "Hausnr.") : "Hausnr.",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "95px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "95px" };
            },
            /*
            filter: selectFilter({ 
                options: this.getFilterOptions(this.state.invests, "hausnummer"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "80px" },
                getFilter: (filter:any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
        };
        this.addFilter2Column2(c, 'hausnummer');
        columns.push(c);


        c = {
            dataField: 'investition.beginnJahr',            
            bez: "Beginnjahr",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Beginnjahr'] ?? "Beginnjahr" ) : "Beginnjahr",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "100px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "100px" };
            },
            /*
            filter: selectFilter({
                options: this.getFilterOptions(this.state.invests, "beginnJahr"),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "85px" },
                getFilter: (filter: any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
        };
        this.addFilter2Column2(c, 'beginnJahr');
        columns.push(c);


        c = {
            dataField: 'summenEbene.produkt',
            isDummyField: true,            
            bez: "Produkt",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Produkt'] ?? "Produkt") : "Produkt",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {

                if (!row.summenEbene /*|| !row.summenEbene.produktText*/)
                    return null

                var text = "";

                if (row.summenEbene.produktEbene)
                    text = row.summenEbene.produktEbene + (row.summenEbene && row.summenEbene.produktText ? " - " + row.summenEbene.produktText : "");
                else 
                    text = Utilities.Num2Str(row.summenEbene && row.summenEbene.produkt !== undefined ? row.summenEbene.produkt : 0, row.summenEbene && row.summenEbene.produktStellen !== undefined ? row.summenEbene.produktStellen : 0) + (row.summenEbene && row.summenEbene.produktText ? " - " + row.summenEbene.produktText : "");

                return (
                    <div>{text}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            /*
            filter: selectFilter({
                options: this.getProduktOptions(this.state.invests),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "85px" },
                getFilter: (filter: any) => { this.getFilters.push(filter); }
            }),            
            filter: customFilter({
                type: FILTER_TYPES.TEXT,
                onFilter: (filterVal: string | undefined, data: KSLPlusAPI.InvestitionsModelDoppik[]) => {
                    if (this.filterVals[dataField] === null) { return data }; if (filterVal && filterVal !== "") return data.filter(r => {
                        const i = r.investition as unknown as { [key: string]: string };
                        return i[dataField] && i[dataField].toLowerCase() === (filterVal?.toLowerCase() ?? "")
                    }); return data;
                }
            }),
            filterRenderer: (onFilter: any, column: any) => {

                return <SelectSearchFilter selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter?.value); }} column={column} filterOptions={this.getProduktOptions(this.state.invests)} />
            },*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                return (
                    row.summenEbene?.produktEbene ? row.summenEbene?.produktEbene : Utilities.Num2Str(row.summenEbene && row.summenEbene.produkt !== undefined ? row.summenEbene.produkt : 0, row.summenEbene && row.summenEbene.produktStellen !== undefined ? row.summenEbene.produktStellen : 0)
                );
            }
        };
        if (this.state.invests.some(i => i.summenEbene?.produktEbene) )
            this.addFilter2Column(c, 'produktEbene', true, this.getProduktOptions(this.state.invests), 'summenEbene');
        else
            this.addFilter2Column(c, 'produkt', true,  this.getProduktOptions(this.state.invests), 'summenEbene' );
        columns.push(c);

        c = {
            dataField: 'summenEbene.ebenen',
            isDummyField: true,
            bez: "Ebene",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Ebene'] ?? "Ebene") : "Ebene",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {

                if (!row.summenEbene)
                    return null;

                var items: JSX.Element[] = [];                
                var idx = 0;

                row.summenEbene?.ebenen?.forEach(e => {                    
                    if (items.length)
                        items.push(<br />);
                    items.push(<div key={"key" + row.summenEbene?.id + "_" + idx++} >{e}</div>);                    
                });

                return (
                    <div>{items}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            /*
            filter: selectFilter({
                options: this.getProduktOptions(this.state.invests),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "85px" },
                getFilter: (filter: any) => { this.getFilters.push(filter); }
            }),     
            */
           /*
            filter: customFilter({                
                onFilter: (filterVal: string | undefined, data: KSLPlusAPI.InvestitionsModelDoppik[]) => {                    
                    alert(this.filterVals["ebene"]);
                    if (this.filterVals["ebene"] === null) { return data };
                    if (filterVal && filterVal !== "") {
                        return data.filter(r => 

                            r.summenEbene?.ebenen?.some(e => e === filterVal.toLowerCase() )
                        

                        );
                    }
                    return data;
                }
            }),            
            filterRenderer: (onFilter: any, column: any) => {

                return <SelectSearchFilter selected={this.filterVals[dataField]} onFilter={(filter: any) => { this.filterVals[dataField] = filter; onFilter(filter?.value); }} column={column} filterOptions={this.getProduktOptions(this.state.invests)} />
            },*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                if (!row.summenEbene)
                    return "";

                var text = "";
                row.summenEbene?.ebenen?.forEach(e => {                              
                    text += e;                    
                });
                return text;
            }
        };
        this.addFilter2Column(c, 'ebenen', true, this.getEbenenOptions(this.state.invests), 'summenEbene', false, "", true);
        columns.push(c);

        c = {
            dataField: 'investition.investitionsart',            
            bez: "Investitionsart",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Investitionsart'] ?? "Investitionsart" ): "Investitionsart",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var ia = this.investitionsarten.find(ia => row.investition && ia.id == row.investition.investitionsart);

                return (
                    <div>{ia != null ? ia.bezeichnung : ""}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "120px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "120px" };
            },
            /*
            filter: selectFilter({
                options: this.getInvestitionsartOptions(this.state.invests,
                    this.investitionsarten ? this.investitionsarten : []),
                placeholder: "Alle", className: "kslplus-tabellen-multiselect",
                style: { width: "115px" },
                getFilter: (filter: any) => { this.getFilters.push(filter) }
            }),
            */
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var ia = this.investitionsarten.find(ia => row.investition && ia.id == row.investition.investitionsart);

                return (
                    ia != null ? ia.bezeichnung : ""
                );
            }
        };
        this.addFilter2Column2(c, 'investitionsart', false, this.getInvestitionsartOptions(this.state.invests, this.investitionsarten ? this.investitionsarten : []));
        columns.push(c);

        c = {
            dataField: 'investition.vermoegensart',            
            bez: "Vermögensart",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Vermögensart'] ?? "Vermögensart") : "Vermögensart",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var va = this.vermoegensarten.find(va => row.investition && va.id == row.investition.vermoegensart);

                return (
                    <div>{va != null ? va.bezeichnung : ""}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },            
            /*
            filter: selectFilter({
                options: this.getVermoegensartOptions(this.state.invests, this.vermoegensarten ? this.vermoegensarten : []),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "145px" },
                getFilter: (filter: any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var va = this.vermoegensarten.find(va => row.investition && va.id == row.investition.vermoegensart);

                return (
                    va != null ? va.bezeichnung : ""
                );
            }
        };
        this.addFilter2Column2(c, 'vermoegensart', false, this.getVermoegensartOptions(this.state.invests, this.vermoegensarten ? this.vermoegensarten : []));
        columns.push(c);

        c = {
            dataField: 'investition.vermoegenstyp',            
            bez: "Vermögenstyp",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Vermögenstyp'] ?? "Vermögenstyp") : "Vermögenstyp",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var va = this.vermoegensarten.find(va => row.investition && va.id == row.investition.vermoegensart);

                var vt = undefined;
                if (va && va.vermoegenstypen) {
                    vt = va.vermoegenstypen.find(vt => row.investition && vt.id == row.investition.vermoegenstyp);
                }

                return (
                    <div>{vt != null ? vt.bezeichnung : ""}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "150px" };
            },            
            /*
            filter: selectFilter(
                {
                    options: this.getVermoegenstypOptions(this.state.invests, this.vermoegensarten ? this.vermoegensarten : []),
                    placeholder: "Alle", className: "kslplus-tabellen-multiselect",
                    style: { width: "145px" },
                    getFilter: (filter: any) => { this.getFilters.push(filter) }
                }
            ),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                var va = this.vermoegensarten.find(va => row.investition && va.id == row.investition.vermoegensart);

                var vt = undefined;
                if (va && va.vermoegenstypen) {
                    vt = va.vermoegenstypen.find(vt => row.investition && vt.id == row.investition.vermoegenstyp);
                }

                return (
                    vt != null ? vt.bezeichnung : ""
                );
            }
        };
        this.addFilter2Column2(c, 'vermoegenstyp', false, this.getVermoegenstypOptions(this.state.invests, this.vermoegensarten ? this.vermoegensarten : []));
        columns.push(c);

        c = {
            dataField: 'investition.wesentlich',            
            bez: "Wesentlich",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Wesentlich'] ?? "Wesentlich") : "Wesentlich",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                return (
                    <div>{row.investition && row.investition.wesentlich ? "ja" : "nein"}</div>);

            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "80px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "80px" };
            },
            /*
            filter: selectFilter({
                options: this.boolSelectOptions,
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "65px" },
                getFilter: (filter: any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
            ,
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                return (
                    row.investition && row.investition.wesentlich ? "ja" : "nein"
                );
            }
        };
        this.addFilter2Column2(c, 'wesentlich', false, this.boolSelectOptions);
        columns.push(c);

        c = {
            dataField: 'summenEbene.investNr',
            isDummyField: true,            
            bez: "Investitions-Nr.",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Investitions-Nr.'] ?? "Investitions-Nr.") : "Investitions-Nr.",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                return (
                    <div className="kslplus-tabellen-bezeichnung">{row.summenEbene && row.summenEbene.investNr ? row.summenEbene.investNr : ""}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            /*
            filter: selectFilter({
                options: this.getInvestNrOptions(this.state.invests),
                placeholder: "Alle",
                className: "kslplus-tabellen-multiselect",
                style: { width: "85px" },
                getFilter: (filter: any) => { this.getFilters.push(filter) }
            }),*/
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            }
        };
        this.addFilter2Column(c, 'investNr', true, this.getInvestNrOptions(this.state.invests), 'summenEbene');
        columns.push(c);

        if (invests.findIndex(i => (i.summenEbene?.teilhaushalt ?? "") !== "") !== -1) {
            c = {
                dataField: 'summenEbene.teilhaushalt',
                isDummyField: true,                
                bez: "Teilhaushalt.",
                text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Teilhaushalt'] ?? "Teilhaushalt") : "Teilhaushalt",
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                    return (
                        <div className="kslplus-tabellen-bezeichnung">{row.summenEbene && row.summenEbene.teilhaushalt ? row.summenEbene.teilhaushalt : ""}</div>
                    );
                },
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                filter: selectFilter({
                    options: this.getTeilhaushaltOptions(this.state.invests),
                    placeholder: "Alle",
                    className: "kslplus-tabellen-multiselect",
                    style: { width: "85px" },
                    getFilter: (filter: any) => { this.getFilters.push(filter) }
                }),
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                }
            };
            this.addFilter2Column(c, 'teilhaushalt', false, this.getTeilhaushaltOptions(this.state.invests), 'summenEbene');
            columns.push(c);
        }

        c = {
            dataField: 'auszahlungsKonto',
            isDummyField: true,            
            bez: "Auszahlungskonto",
            text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Auszahlungskonto'] ?? "Auszahlungskonto") : "Auszahlungskonto",
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {

                if (!row.ebenen)
                    return null;

                var kontenItems: JSX.Element[] = [];
                var konten: string[] = [];
                row.ebenen.forEach(e => {                     
                    if (e.ausgabe && !konten.some(k => k === Utilities.Num2Str(e.ebene?.konto ?? 0, e.ebene?.kontoStellen ?? 0))) {
                        if (kontenItems.length)
                            kontenItems.push(<br />);

                        var text = Utilities.Num2Str(e.ebene?.konto ?? 0, e.ebene?.kontoStellen ?? 0) + " - " + (e.ebene?.kontoText ?? "");
                        konten.push(Utilities.Num2Str(e.ebene?.konto ?? 0, e.ebene?.kontoStellen ?? 0));
                        //var text = "test";
                        kontenItems.push(<div key={"key" + e.ebene?.id} >{text}</div>);
                    }
                });
                
                return (
                    <div>{kontenItems}</div>
                );
            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },
            style: (colum: any, colIndex: any) => {
                return { width: "220px" };
            },            
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortValue: (cell: any, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                if (!row.ebenen)
                    return "";
                var text = "";
                row.ebenen.forEach(e => {                   
                    if (e.ausgabe) {                        
                        text += Utilities.Num2Str(e.ebene?.konto ?? 0, e.ebene?.kontoStellen ?? 0) + " - " + (e.ebene?.kontoText ?? "");                        
                    }
                });
                return text;
            }
        };
        this.addFilter2Column(c, 'konto', true, this.getKontenOptions(this.state.invests), 'ebenen', true, 'ebene');
        columns.push(c);

        columns.push(
            {
                dataField: 'summenEbene',
                isDummyField: true,                
                bez: "Summe-Ausz.",
                text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Summe-Ausz.'] ?? "Summe-Ausz.") : "Summe-Ausz.",
                headerAlign: 'right',
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModel) => {
                    var sum = 0;
                    if (this.props.plantyp === 3) {
                        sum += row.summenEbene?.ergebnisPJ_soll ?? 0;
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3)
                            sum += row.summenEbene?.ergebnisPJM4_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2)
                            sum += row.summenEbene?.ergebnisPJM3_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisPJM2_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0)
                            sum += row.summenEbene?.ergebnisPJM1_soll ?? 0;

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sum += row.summenEbene?.ansatzPJfort_soll ?? 0;
                                break;

                            case 0:
                                sum += row.summenEbene?.ergebnisPJ_soll ?? 0;
                                break;
                        }
                    }
                    else {
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2)
                            sum += row.summenEbene?.ergebnisVvvJ_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisVvJ_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && row.summenEbene?.hasVJErg)
                                sum += row.summenEbene?.ergebnisPJM1_soll ?? 0;
                            else
                                sum += row.summenEbene?.ansatzVJ_soll ?? 0;
                        }
                        sum += row.summenEbene?.ansatzPj_soll ?? 0;
                    }
                    if (this.props.plantyp == 3) {
                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3)
                            sum += row.summenEbene?.ergebnisPJM4_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2)
                            sum += row.summenEbene?.ergebnisPJM3_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisPJM2_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0)
                            sum += row.summenEbene?.ergebnisPJM1_soll ?? 0;
                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0)
                            sum += row.summenEbene?.fp1_soll ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1)
                            sum += row.summenEbene?.fp2_soll ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2)
                            sum += row.summenEbene?.fp3_soll ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3)
                            sum += row.summenEbene?.fp4_soll ?? 0;
                    }

                    return (
                        <div>{Utilities.FormatCurrency(sum, this.props.settings.nk, 3, '.', ',')}</div>
                    );
                },
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                sortFunc: (a: KSLPlusAPI.HaushaltsEbene, b: KSLPlusAPI.HaushaltsEbene, order: string, dataField: any) => {
                    var sumA = 0;
                    var sumB = 0;
                    if (this.props.plantyp === 3) {
                        sumA += a.ergebnisPJ_soll ?? 0;
                        sumB += b.ergebnisPJ_soll ?? 0;
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                            sumA += a.ergebnisPJM1_soll ?? 0;
                            sumB += b.ergebnisPJM1_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                            sumA += a.ergebnisPJM2_soll ?? 0;
                            sumB += b.ergebnisPJM2_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                            sumA += a.ergebnisPJM3_soll ?? 0;
                            sumB += b.ergebnisPJM3_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                            sumA += a.ergebnisPJM4_soll ?? 0;
                            sumB += b.ergebnisPJM4_soll ?? 0;
                        }

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sumA += a.ansatzPJfort_soll ?? 0;
                                sumB += b.ansatzPJfort_soll ?? 0;
                                break;

                            case 0:
                                sumA += a.ergebnisPJ_soll ?? 0;
                                sumB += b.ergebnisPJ_soll ?? 0;
                                break;
                        }


                    }
                    else {
                        sumA += a.ansatzPj_soll ?? 0;
                        sumB += b.ansatzPj_soll ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                            sumA += a.ergebnisVvvJ_soll ?? 0;
                            sumB += b.ergebnisVvvJ_soll ?? 0;
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                            sumA += a.ergebnisVvJ_soll ?? 0;
                            sumB += b.ergebnisVvJ_soll ?? 0;
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && a.hasVJErg) {
                                sumA += a.ergebnisPJM1_soll ?? 0;
                                sumB += b.ergebnisPJM1_soll ?? 0;
                            }
                            else {
                                sumA += a.ansatzVJ_soll ?? 0;
                                sumB += b.ansatzVJ_soll ?? 0;
                            }
                        }
                    }
                    if (this.props.plantyp == 3) {

                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0) {
                            sumA += a.ergebnisPJM1_soll ?? 0;
                            sumB += b.ergebnisPJM1_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1) {
                            sumA += a.ergebnisPJM2_soll ?? 0;
                            sumB += b.ergebnisPJM2_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2) {
                            sumA += a.ergebnisPJM3_soll ?? 0;
                            sumB += b.ergebnisPJM3_soll ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                            sumA += a.ergebnisPJM4_soll ?? 0;
                            sumB += b.ergebnisPJM4_soll ?? 0;
                        }
                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                            sumA += a.fp1_soll ?? 0;
                            sumB += b.fp1_soll ?? 0;

                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                            sumA += a.fp2_soll ?? 0;
                            sumB += b.fp2_soll ?? 0;
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                            sumA += a.fp3_soll ?? 0;
                            sumB += b.fp3_soll ?? 0;
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                            sumA += a.fp4_soll ?? 0;
                            sumB += b.fp4_soll ?? 0;
                        }
                    }
                    if (order === 'asc') {
                        return sumB - sumA;
                    }
                    return sumA - sumB; // desc
                }

            }
        );

        if (this.props.plantyp === 4) {
            columns.push(
                {
                    dataField: 'summenEbene',
                    isDummyField: true,                    
                    bez: "Geldfluss-Ausz.",
                    text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Geldfluss-Ausz.'] ?? "Geldfluss-Ausz.") : "Geldfluss-Ausz.",
                    headerAlign: 'right',
                    align: 'right',
                    formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                        return (
                            <div>{Utilities.FormatCurrency(row.summenEbene?.verfuegtPJ_soll ?? 0, this.props.settings.nk, 3, '.', ',')}</div>
                        );
                    },
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: "150px" };
                    },
                    style: (colum: any, colIndex: any) => {
                        return { width: "150px" };
                    },
                    sort: true,
                    sortCaret: (order: string, column: any) => {
                        if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                        else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                        else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                        return null;
                    },
                    sortFunc: (a: KSLPlusAPI.HaushaltsEbeneDoppik, b: KSLPlusAPI.HaushaltsEbeneDoppik, order: string, dataField: any) => {                        
                        if (order === 'asc') {
                            return (b.verfuegtPJ_soll ?? 0) - (a.verfuegtPJ_soll ?? 0);
                        }
                        return (a.verfuegtPJ_soll ?? 0) - (b.verfuegtPJ_soll ?? 0); // desc
                    }

                }
            );

            
        }


        columns.push(
            {
                dataField: 'summenEbene',
                isDummyField: true,                
                bez: "Summe-Einz.",
                text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Summe-Einz.'] ?? "Summe-Einz.") : "Summe-Einz.",
                headerAlign: 'right',
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModel) => {
                    var sum = 0;
                    if (this.props.plantyp === 3) {
                        sum += row.summenEbene?.ergebnisPJ_haben ?? 0;
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3)
                            sum += row.summenEbene?.ergebnisPJM4_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2)
                            sum += row.summenEbene?.ergebnisPJM3_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisPJM2_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0)
                            sum += row.summenEbene?.ergebnisPJM1_haben ?? 0;

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sum += row.summenEbene?.ansatzPJfort_haben ?? 0;
                                break;

                            case 0:
                                sum += row.summenEbene?.ergebnisPJ_haben ?? 0;
                                break;
                        }
                    }
                    else {
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2)
                            sum += row.summenEbene?.ergebnisVvvJ_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisVvJ_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && row.summenEbene?.hasVJErg)
                                sum += row.summenEbene?.ergebnisPJM1_haben ?? 0;
                            else
                                sum += row.summenEbene?.ansatzVJ_haben ?? 0;
                        }
                        sum += row.summenEbene?.ansatzPj_haben ?? 0;
                    }
                    if (this.props.plantyp == 3) {
                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3)
                            sum += row.summenEbene?.ergebnisPJM4_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2)
                            sum += row.summenEbene?.ergebnisPJM3_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1)
                            sum += row.summenEbene?.ergebnisPJM2_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0)
                            sum += row.summenEbene?.ergebnisPJM1_haben ?? 0;
                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0)
                            sum += row.summenEbene?.fp1_haben ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1)
                            sum += row.summenEbene?.fp2_haben ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2)
                            sum += row.summenEbene?.fp3_haben ?? 0;
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3)
                            sum += row.summenEbene?.fp4_haben ?? 0;
                    }

                    return (
                        <div>{Utilities.FormatCurrency(sum, this.props.settings.nk, 3, '.', ',')}</div>
                    );
                },
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                sortFunc: (a: KSLPlusAPI.HaushaltsEbene, b: KSLPlusAPI.HaushaltsEbene, order: string, dataField: any) => {

                    var sumA = 0;
                    var sumB = 0;
                    if (this.props.plantyp === 3) {
                        sumA += a.ergebnisPJ_haben ?? 0;
                        sumB += b.ergebnisPJ_haben ?? 0;
                    }
                    else if (this.props.plantyp === 4) {

                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                            sumA += a.ergebnisPJM1_haben ?? 0;
                            sumB += b.ergebnisPJM1_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                            sumA += a.ergebnisPJM2_haben ?? 0;
                            sumB += b.ergebnisPJM2_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                            sumA += a.ergebnisPJM3_haben ?? 0;
                            sumB += b.ergebnisPJM3_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                            sumA += a.ergebnisPJM4_haben ?? 0;
                            sumB += b.ergebnisPJM4_haben ?? 0;
                        }

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sumA += a.ansatzPJfort_haben ?? 0;
                                sumB += b.ansatzPJfort_haben ?? 0;
                                break;

                            case 0:
                                sumA += a.ergebnisPJ_haben ?? 0;
                                sumB += b.ergebnisPJ_haben ?? 0;
                                break;
                        }
                    }
                    else {
                        sumA += a.ansatzPj_haben ?? 0;
                        sumB += b.ansatzPj_haben ?? 0;
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                            sumA += a.ergebnisVvvJ_haben ?? 0;
                            sumB += b.ergebnisVvvJ_haben ?? 0;
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                            sumA += a.ergebnisVvJ_haben ?? 0;
                            sumB += b.ergebnisVvJ_haben ?? 0;
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && a.hasVJErg) {
                                sumA += a.ergebnisPJM1_haben ?? 0;
                                sumB += b.ergebnisPJM1_haben ?? 0;
                            }
                            else {
                                sumA += a.ansatzVJ_haben ?? 0;
                                sumB += b.ansatzVJ_haben ?? 0;
                            }
                        }
                    }
                    if (this.props.plantyp == 3) {

                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0) {
                            sumA += a.ergebnisPJM1_haben ?? 0;
                            sumB += b.ergebnisPJM1_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1) {
                            sumA += a.ergebnisPJM2_haben ?? 0;
                            sumB += b.ergebnisPJM2_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2) {
                            sumA += a.ergebnisPJM3_haben ?? 0;
                            sumB += b.ergebnisPJM3_haben ?? 0;
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                            sumA += a.ergebnisPJM4_haben ?? 0;
                            sumB += b.ergebnisPJM4_haben ?? 0;
                        }
                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                            sumA += a.fp1_haben ?? 0;
                            sumB += b.fp1_haben ?? 0;

                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                            sumA += a.fp2_haben ?? 0;
                            sumB += b.fp2_haben ?? 0;
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                            sumA += a.fp3_haben ?? 0;
                            sumB += b.fp3_haben ?? 0;
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                            sumA += a.fp4_haben ?? 0;
                            sumB += b.fp4_haben ?? 0;
                        }
                    }
                    if (order === 'asc') {
                        return sumB - sumA;
                    }
                    return sumA - sumB; // desc
                }

            }
        );

        if (this.props.plantyp === 4) {
            columns.push(
                {
                    dataField: 'summenEbene',
                    isDummyField: true,                    
                    bez: "Geldfluss-Einz.",
                    text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Geldfluss-Einz.'] ?? "Geldfluss-Einz.") : "Geldfluss-Einz.",
                    headerAlign: 'right',
                    align: 'right',
                    formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                        return (
                            <div>{Utilities.FormatCurrency(row.summenEbene?.verfuegtPJ_haben ?? 0, this.props.settings.nk, 3, '.', ',')}</div>
                        );
                    },
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: "150px" };
                    },
                    style: (colum: any, colIndex: any) => {
                        return { width: "150px" };
                    },
                    sort: true,
                    sortCaret: (order: string, column: any) => {
                        if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                        else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                        else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                        return null;
                    },
                    sortFunc: (a: KSLPlusAPI.HaushaltsEbeneDoppik, b: KSLPlusAPI.HaushaltsEbeneDoppik, order: string, dataField: any) => {
                        if (order === 'asc') {
                            return (b.verfuegtPJ_haben ?? 0) - (a.verfuegtPJ_haben ?? 0);
                        }
                        return (a.verfuegtPJ_haben ?? 0) - (b.verfuegtPJ_haben ?? 0); // desc
                    }

                }
            );
        }

        columns.push(
            {
                dataField: 'summenEbene',
                isDummyField: true,
                bez: "Summe-Eigenm.",
                text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Summe-Eigenm.'] ?? "Summe-Eigenm.") : "Summe-Eigenm.",
                headerAlign: 'right',
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModelDoppik) => {
                    var sum = 0;
                    if (this.props.plantyp === 3) {
                        sum += ((row.summenEbene?.ergebnisPJ_soll ?? 0) - (row.summenEbene?.ergebnisPJ_haben ?? 0));
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3)
                            sum += ((row.summenEbene?.ergebnisPJM4_soll ?? 0) - (row.summenEbene?.ergebnisPJM4_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2)
                            sum += ((row.summenEbene?.ergebnisPJM3_soll ?? 0) - (row.summenEbene?.ergebnisPJM3_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1)
                            sum += ((row.summenEbene?.ergebnisPJM2_soll ?? 0) - (row.summenEbene?.ergebnisPJM2_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0)
                            sum += ((row.summenEbene?.ergebnisPJM1_soll ?? 0) - (row.summenEbene?.ergebnisPJM1_haben ?? 0));

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sum += ((row.summenEbene?.ansatzPJfort_soll ?? 0) - (row.summenEbene?.ansatzPJfort_haben ?? 0));
                                break;

                            case 0:
                                sum += ((row.summenEbene?.ergebnisPJ_soll ?? 0) - (row.summenEbene?.ergebnisPJ_haben ?? 0));
                                break;
                        }
                    }
                    else {
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2)
                            sum += ((row.summenEbene?.ergebnisVvvJ_soll ?? 0) - (row.summenEbene?.ergebnisVvvJ_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1)
                            sum += ((row.summenEbene?.ergebnisVvJ_soll ?? 0) - (row.summenEbene?.ergebnisVvJ_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && row.summenEbene?.hasVJErg)
                                sum += ((row.summenEbene?.ergebnisPJM1_soll ?? 0) - (row.summenEbene?.ergebnisPJM1_haben ?? 0));
                            else
                                sum += ((row.summenEbene?.ansatzVJ_soll ?? 0) - (row.summenEbene?.ansatzVJ_haben ?? 0));
                        }
                        sum += ((row.summenEbene?.ansatzPj_soll ?? 0) - (row.summenEbene?.ansatzPj_haben ?? 0));
                    }
                    if (this.props.plantyp == 3) {
                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3)
                            sum += ((row.summenEbene?.ergebnisPJM4_soll ?? 0) - (row.summenEbene?.ergebnisPJM4_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2)
                            sum += ((row.summenEbene?.ergebnisPJM3_soll ?? 0) - (row.summenEbene?.ergebnisPJM3_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1)
                            sum += ((row.summenEbene?.ergebnisPJM2_soll ?? 0) - (row.summenEbene?.ergebnisPJM2_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0)
                            sum += ((row.summenEbene?.ergebnisPJM1_soll ?? 0) - (row.summenEbene?.ergebnisPJM1_haben ?? 0));

                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0)
                            sum += ((row.summenEbene?.fp1_soll ?? 0) - (row.summenEbene?.fp1_haben ?? 0));
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1)
                            sum += ((row.summenEbene?.fp2_soll ?? 0) - (row.summenEbene?.fp2_haben ?? 0));
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2)
                            sum += ((row.summenEbene?.fp3_soll ?? 0) - (row.summenEbene?.fp3_haben ?? 0));
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3)
                            sum += ((row.summenEbene?.fp4_soll ?? 0) - (row.summenEbene?.fp4_haben ?? 0));
                    }

                    return (
                        <div>{Utilities.FormatCurrency(sum, this.props.settings.nk, 3, '.', ',')}</div>
                    );
                },
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                sortFunc: (a: KSLPlusAPI.HaushaltsEbene, b: KSLPlusAPI.HaushaltsEbene, order: string, dataField: any) => {
                    var sumA = 0;
                    var sumB = 0;
                    if (this.props.plantyp === 3) {
                        sumA += ((a.ergebnisPJ_soll ?? 0) - (a.ergebnisPJ_haben ?? 0));
                        sumB += ((b.ergebnisPJ_soll ?? 0) - (b.ergebnisPJ_haben ?? 0));
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                            sumA += ((a.ergebnisPJM1_soll ?? 0) - (a.ergebnisPJM1_haben ?? 0));
                            sumB += ((b.ergebnisPJM1_soll ?? 0) - (b.ergebnisPJM1_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                            sumA += ((a.ergebnisPJM2_soll ?? 0) - (a.ergebnisPJM2_haben ?? 0));
                            sumB += ((b.ergebnisPJM2_soll ?? 0) - (b.ergebnisPJM2_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                            sumA += ((a.ergebnisPJM3_soll ?? 0) - (a.ergebnisPJM3_haben ?? 0));
                            sumB += ((b.ergebnisPJM3_soll ?? 0) - (b.ergebnisPJM3_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                            sumA += ((a.ergebnisPJM4_soll ?? 0) - (a.ergebnisPJM4_haben ?? 0));
                            sumB += ((b.ergebnisPJM4_soll ?? 0) - (b.ergebnisPJM4_haben ?? 0));
                        }

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sumA += ((a.ansatzPJfort_soll ?? 0) - (a.ansatzPJfort_haben ?? 0));
                                sumB += ((b.ansatzPJfort_soll ?? 0) - (b.ansatzPJfort_haben ?? 0));
                                break;

                            case 0:
                                sumA += ((a.ergebnisPJ_soll ?? 0) - (a.ergebnisPJ_haben ?? 0));
                                sumB += ((b.ergebnisPJ_soll ?? 0) - (b.ergebnisPJ_haben ?? 0));
                                break;
                        }

                    }
                    else {
                        sumA += ((a.ansatzPj_soll ?? 0) - (a.ansatzPj_haben ?? 0));
                        sumB += ((b.ansatzPj_soll ?? 0) - (b.ansatzPj_haben ?? 0));
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                            sumA += ((a.ergebnisVvvJ_soll ?? 0) - (a.ergebnisVvvJ_haben ?? 0));
                            sumB += ((b.ergebnisVvvJ_soll ?? 0) - (b.ergebnisVvvJ_haben ?? 0));
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                            sumA += ((a.ergebnisVvJ_soll ?? 0) - (a.ergebnisVvJ_haben ?? 0));
                            sumB += ((b.ergebnisVvJ_soll ?? 0) - (b.ergebnisVvJ_haben ?? 0));
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && a.hasVJErg) {
                                sumA += ((a.ergebnisPJM1_soll ?? 0) - (a.ergebnisPJM1_haben ?? 0));
                                sumB += ((b.ergebnisPJM1_soll ?? 0) - (b.ergebnisPJM1_haben ?? 0));
                            }
                            else {
                                sumA += ((a.ansatzVJ_soll ?? 0) - (a.ansatzVJ_haben ?? 0));
                                sumB += ((b.ansatzVJ_soll ?? 0) - (b.ansatzVJ_haben ?? 0));
                            }
                        }
                    }
                    if (this.props.plantyp == 3) {

                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0) {
                            sumA += ((a.ergebnisPJM1_soll ?? 0) - (a.ergebnisPJM1_haben ?? 0));
                            sumB += ((b.ergebnisPJM1_soll ?? 0) - (b.ergebnisPJM1_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1) {
                            sumA += ((a.ergebnisPJM2_soll ?? 0) - (a.ergebnisPJM2_haben ?? 0));
                            sumB += ((b.ergebnisPJM2_soll ?? 0) - (b.ergebnisPJM2_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2) {
                            sumA += ((a.ergebnisPJM3_soll ?? 0) - (a.ergebnisPJM3_haben ?? 0));
                            sumB += ((b.ergebnisPJM3_soll ?? 0) - (b.ergebnisPJM3_haben ?? 0));
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                            sumA += ((a.ergebnisPJM4_soll ?? 0) - (a.ergebnisPJM4_haben ?? 0));
                            sumB += ((b.ergebnisPJM4_soll ?? 0) - (b.ergebnisPJM4_haben ?? 0));
                        }
                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                            sumA += ((a.fp1_soll ?? 0) - (a.fp1_haben ?? 0));
                            sumB += ((b.fp1_soll ?? 0) - (b.fp1_haben ?? 0));

                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                            sumA += ((a.fp2_soll ?? 0) - (a.fp2_haben ?? 0));
                            sumB += ((b.fp2_soll ?? 0) - (b.fp2_haben ?? 0));
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                            sumA += ((a.fp3_soll ?? 0) - (a.fp3_haben ?? 0));
                            sumB += ((b.fp3_soll ?? 0) - (b.fp3_haben ?? 0));
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                            sumA += ((a.fp4_soll ?? 0) - (a.fp4_haben ?? 0));
                            sumB += ((b.fp4_soll ?? 0) - (b.fp4_haben ?? 0));
                        }
                    }
                    if (order === 'asc') {
                        return sumB - sumA;
                    }
                    return sumA - sumB; // desc
                }

            }
        );

        columns.push(
            {
                dataField: 'summenEbene',
                isDummyField: true,
                bez: "Fördermittelquote in %",
                text: this.props.investSettings.spaltenBezMap ? (this.props.investSettings.spaltenBezMap['Fördermittelquote in %'] ?? "Fördermittelquote in %") : "Fördermittelquote in %",
                headerAlign: 'right',
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsModel) => {
                    var sumA = 0;
                    var sumE = 0;
                    if (this.props.plantyp === 3) {
                        sumA += (row.summenEbene?.ergebnisPJ_soll ?? 0)
                        sumE += (row.summenEbene?.ergebnisPJ_haben ?? 0);
                    }
                    else if (this.props.plantyp === 4) {
                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                            sumA += (row.summenEbene?.ergebnisPJM4_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM4_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                            sumA += (row.summenEbene?.ergebnisPJM3_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM3_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                            sumA += (row.summenEbene?.ergebnisPJM2_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM2_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                            sumA += (row.summenEbene?.ergebnisPJM1_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM1_haben ?? 0);
                        }

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sumA += (row.summenEbene?.ansatzPJfort_soll ?? 0);
                                sumE += (row.summenEbene?.ansatzPJfort_haben ?? 0);
                                break;

                            case 0:
                                sumA += (row.summenEbene?.ergebnisPJ_soll ?? 0)
                                sumE += (row.summenEbene?.ergebnisPJ_haben ?? 0);
                                break;
                        }
                    }
                    else {
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                            sumA += (row.summenEbene?.ergebnisVvvJ_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisVvvJ_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                            sumA += (row.summenEbene?.ergebnisVvJ_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisVvJ_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && row.summenEbene?.hasVJErg) {
                                sumA += (row.summenEbene?.ergebnisPJM1_soll ?? 0)
                                sumE += (row.summenEbene?.ergebnisPJM1_haben ?? 0);
                            }
                            else {
                                sumA += (row.summenEbene?.ansatzVJ_soll ?? 0)
                                sumE += (row.summenEbene?.ansatzVJ_haben ?? 0);
                            }
                        }
                        sumA += (row.summenEbene?.ansatzPj_soll ?? 0)
                        sumE += (row.summenEbene?.ansatzPj_haben ?? 0);
                    }
                    if (this.props.plantyp == 3) {
                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                            sumA += (row.summenEbene?.ergebnisPJM4_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM4_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2) {
                            sumA += (row.summenEbene?.ergebnisPJM3_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM3_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1) {
                            sumA += (row.summenEbene?.ergebnisPJM2_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM2_haben ?? 0);
                        }
                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0) {
                            sumA += (row.summenEbene?.ergebnisPJM1_soll ?? 0)
                            sumE += (row.summenEbene?.ergebnisPJM1_haben ?? 0);
                        }

                    }
                    else if (this.props.plantyp < 3) {
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                            sumA += (row.summenEbene?.fp1_soll ?? 0)
                            sumE += (row.summenEbene?.fp1_haben ?? 0);
                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                            sumA += (row.summenEbene?.fp2_soll ?? 0)
                            sumE += (row.summenEbene?.fp2_haben ?? 0);
                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                            sumA += (row.summenEbene?.fp3_soll ?? 0)
                            sumE += (row.summenEbene?.fp3_haben ?? 0);
                        }
                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                            sumA += (row.summenEbene?.fp4_soll ?? 0)
                            sumE += (row.summenEbene?.fp4_haben ?? 0);
                        }
                    }

                    return (
                        <div>{Utilities.FormatCurrency(sumA !== 0 ? sumE / sumA * 100 : (sumE === 0 ? 0 : undefined), this.props.settings.nk, 3, '.', ',')}</div>
                    );
                },
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "150px" };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                sortFunc: (a: KSLPlusAPI.HaushaltsEbene, b: KSLPlusAPI.HaushaltsEbene, order: string, dataField: any) => {
                    var sumA_a = 0;
                    var sumE_a = 0;
                    var sumA_b = 0;
                    var sumE_b = 0;

                    if (this.props.plantyp === 3) {
                        sumA_a += (a.ergebnisPJ_soll ?? 0);
                        sumE_a += (a.ergebnisPJ_haben ?? 0);

                        sumA_b += (b.ergebnisPJ_soll ?? 0);
                        sumE_b += (b.ergebnisPJ_haben ?? 0);
                    }
                    else if (this.props.plantyp === 4) {

                        if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                            sumA_a += (a.ergebnisPJM1_soll ?? 0);
                            sumE_a += (a.ergebnisPJM1_haben ?? 0);

                            sumA_b += (b.ergebnisPJM1_soll ?? 0);
                            sumE_b += (b.ergebnisPJM1_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                            sumA_a += (a.ergebnisPJM2_soll ?? 0);
                            sumE_a += (a.ergebnisPJM2_haben ?? 0);

                            sumA_b += (b.ergebnisPJM2_soll ?? 0);
                            sumE_b += (b.ergebnisPJM2_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                            sumA_a += (a.ergebnisPJM3_soll ?? 0);
                            sumE_a += (a.ergebnisPJM3_haben ?? 0);

                            sumA_b += (b.ergebnisPJM3_soll ?? 0);
                            sumE_b += (b.ergebnisPJM3_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                            sumA_a += (a.ergebnisPJM4_soll ?? 0);
                            sumE_a += (a.ergebnisPJM4_haben ?? 0);

                            sumA_b += (b.ergebnisPJM4_soll ?? 0);
                            sumE_b += (b.ergebnisPJM4_haben ?? 0);
                        }

                        switch ((this.props.investSettings.endJahrSumUh ?? 32767)) {
                            case 32767:
                                sumA_a += (a.ansatzPJfort_soll ?? 0);
                                sumE_a += (a.ansatzPJfort_haben ?? 0);

                                sumA_b += (b.ansatzPJfort_soll ?? 0);
                                sumE_b += (b.ansatzPJfort_haben ?? 0);
                                break;

                            case 0:
                                sumA_a += (a.ergebnisPJ_soll ?? 0);
                                sumE_a += (a.ergebnisPJ_haben ?? 0);

                                sumA_b += (b.ergebnisPJ_soll ?? 0);
                                sumE_b += (b.ergebnisPJ_haben ?? 0);
                                break;
                        }
                    }
                    else {
                        sumA_a += (a.ansatzPj_soll ?? 0);
                        sumE_a += (a.ansatzPj_haben ?? 0);

                        sumA_b += (b.ansatzPj_soll ?? 0);
                        sumE_b += (b.ansatzPj_haben ?? 0);

                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                            sumA_a += (a.ergebnisVvvJ_soll ?? 0);
                            sumE_a += (a.ergebnisVvvJ_haben ?? 0);

                            sumA_b += (b.ergebnisVvvJ_soll ?? 0);
                            sumE_b += (b.ergebnisVvvJ_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                            sumA_a += (a.ergebnisVvJ_soll ?? 0);
                            sumE_a += (a.ergebnisVvJ_haben ?? 0);

                            sumA_b += (b.ergebnisVvJ_soll ?? 0);
                            sumE_b += (b.ergebnisVvJ_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumHp ?? -2) < 0) {
                            if (this.props.investSettings.vjergInSum && a.hasVJErg) {
                                sumA_a += (a.ergebnisPJM1_soll ?? 0);
                                sumE_a += (a.ergebnisPJM1_haben ?? 0);

                                sumA_b += (b.ergebnisPJM1_soll ?? 0);
                                sumE_b += (b.ergebnisPJM1_haben ?? 0);
                            }
                            else {
                                sumA_a += (a.ansatzVJ_soll ?? 0);
                                sumE_a += (a.ansatzVJ_haben ?? 0);

                                sumA_b += (b.ansatzVJ_soll ?? 0);
                                sumE_b += (b.ansatzVJ_haben ?? 0);
                            }
                        }
                    }

                    if (this.props.plantyp === 3) {

                        if ((this.props.investSettings.startJahrSumJr ?? -1) < 0) {
                            sumA_a += (a.ergebnisPJM1_soll ?? 0);
                            sumE_a += (a.ergebnisPJM1_haben ?? 0);

                            sumA_b += (b.ergebnisPJM1_soll ?? 0);
                            sumE_b += (b.ergebnisPJM1_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -2) < -1) {
                            sumA_a += (a.ergebnisPJM2_soll ?? 0);
                            sumE_a += (a.ergebnisPJM2_haben ?? 0);

                            sumA_b += (b.ergebnisPJM2_soll ?? 0);
                            sumE_b += (b.ergebnisPJM2_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -3) < -2) {
                            sumA_a += (a.ergebnisPJM3_soll ?? 0);
                            sumE_a += (a.ergebnisPJM3_haben ?? 0);

                            sumA_b += (b.ergebnisPJM3_soll ?? 0);
                            sumE_b += (b.ergebnisPJM3_haben ?? 0);
                        }

                        if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                            sumA_a += (a.ergebnisPJM4_soll ?? 0);
                            sumE_a += (a.ergebnisPJM4_haben ?? 0);

                            sumA_b += (b.ergebnisPJM4_soll ?? 0);
                            sumE_b += (b.ergebnisPJM4_haben ?? 0);
                        }
                    }
                    else if (this.props.plantyp < 3) {

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                            sumA_a += (a.fp1_soll ?? 0);
                            sumE_a += (a.fp1_haben ?? 0);

                            sumA_b += (b.fp1_soll ?? 0);
                            sumE_b += (b.fp1_haben ?? 0);
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                            sumA_a += (a.fp2_soll ?? 0);
                            sumE_a += (a.fp2_haben ?? 0);

                            sumA_b += (b.fp2_soll ?? 0);
                            sumE_b += (b.fp2_haben ?? 0);
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                            sumA_a += (a.fp3_soll ?? 0);
                            sumE_a += (a.fp3_haben ?? 0);

                            sumA_b += (b.fp3_soll ?? 0);
                            sumE_b += (b.fp3_haben ?? 0);
                        }

                        if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                            sumA_a += (a.fp4_soll ?? 0);
                            sumE_a += (a.fp4_haben ?? 0);

                            sumA_b += (b.fp4_soll ?? 0);
                            sumE_b += (b.fp4_haben ?? 0);
                        }
                    }



                    const qA = sumA_a !== 0 ? sumE_a / sumA_a : 0;
                    const qB = sumA_b !== 0 ? sumE_b / sumA_b : 0;

                    // Quotient 0 bei Dividend != 0 immer ans Ende
                    const lastA = qA === 0 && sumE_a !== 0;
                    const lastB = qB === 0 && sumE_b !== 0;

                    if (lastA !== lastB) {
                        return lastA ? 1 : -1;
                    }

                    // Normale Sortierung
                    if (order === 'asc') {
                        return qB - qA;
                    }

                    return qA - qB; // desc
                }

            }
        );

        var columns1: any[] = [];

        var anzeigeSpalten = spalten.split(",");

        anzeigeSpalten.forEach(s => {
            //var s1 = columns.filter(s2 => s2.bez.replace("Bezeichnung Maßnahme", "Bezeichnung").replace(/\u00df/g, "ss").replace(/\u00f6/g, "oe") === s.replace(/\u00df/g, "ss").replace(/\u00f6/g, "oe"));
            var s1 = columns.filter(s2 => s2.bez === s);
            if (s1.length > 0)
                columns1.push(s1[0]);
        });

        if (!this.props.settings.hhStellenOeffentlich) 
            columns1.unshift(columns[0]);        

        return columns1.length > 0 ? columns1 : columns;
    }

    createBeschreibungsItems = (texte: KSLPlusAPI.Texte[] | undefined, ve: boolean, ga: boolean) => {
        var items: JSX.Element[] = [];

        if (!texte)
            return items;

        for (var i = 0; i < texte.length; i++) {
            if (ve && ga) {
                items.push(
                    <Row key={"be" + i.toString()}>
                        <Col lg="3">
                            <div className="kslplus-invest-popover-bezeichnung">{texte[i].bezeichnung}:</div>
                        </Col>
                        <Col lg="9">
                            <div className="kslplus-invest-popover-beschreibung">{texte[i].text}</div>
                        </Col>

                    </Row>
                );
            }
            else {
                items.push(
                    <Row key={"be" + i.toString()}>
                        <Col lg="4">
                            <div className="kslplus-invest-popover-bezeichnung">{texte[i].bezeichnung}:</div>
                        </Col>
                        <Col lg="8">
                            <div className="kslplus-invest-popover-beschreibung">{texte[i].text}</div>
                        </Col>

                    </Row>
                );
            }
        }

        return items;

    }

    createWerteItems = (invest: KSLPlusAPI.InvestitionsModelDoppik, ve: boolean, ga: boolean) => {
        var items: JSX.Element[] = [];

        if (!invest.investition)
            return items;

        if (ve && ga) {
            items.push(
                <Row key="1">
                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">Gesamtausgabebedarf:</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtbedarf, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">{"Summe der VE für HH " + (this.props.jahr).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veGesamt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>



                </Row>
            );
            items.push(
                <Row key="2">
                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">Zuwendungen gesamt:</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtzuwendungen, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>

                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 1).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj1, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            items.push(
                <Row key="3">
                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">Zuwendungsquote:</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtbedarf && invest.investition.gesamtzuwendungen ? invest.investition.gesamtzuwendungen * 100 / invest.investition.gesamtbedarf : 0, 2, 3, '.', ',') + " %"}</div>
                    </Col>

                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 2).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj2, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            items.push(
                <Row key="4">
                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">Bisher vereinnahmt:</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.bisherVereinnahmt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 3).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj3, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            items.push(
                <Row key="5">
                    <Col lg="3">
                        <div className="kslplus-invest-popover-bezeichnung">Bisher verausgabt:</div>
                    </Col >
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.bisherVerausgabt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>
                    {this.props.settings.doppelhaushalt ?
                        <>
                            <Col lg="3">
                                <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 4).toString() + ":"}</div>
                            </Col>
                            <Col lg="2" className="kslplus-invest-popover-wert">
                                <div>{Utilities.FormatCurrency(invest.investition.veFj4, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                            </Col>
                        </>
                        :
                        <>
                            <Col lg="3">

                            </Col>
                            <Col lg="2" className="kslplus-invest-popover-wert">

                            </Col>
                        </>
                    }

                </Row>
            );
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0)
            {
                items.push(
                    <Row key="4">
                        <Col lg="3">
                            
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            
                        </Col>


                        {(this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) ?
                            <>
                                <Col lg="3">
                                    <div className="kslplus-invest-popover-bezeichnung">{"Summe der VE für HH " + (this.props.jahr + 1).toString() + ":"}</div>
                                </Col>
                                <Col lg="2" className="kslplus-invest-popover-wert">
                                    <div>{Utilities.FormatCurrency(invest.investition.ve1Gesamt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                                </Col>
                            </>
                            :
                            <>
                                <Col lg="3">

                                </Col>
                                <Col lg="2" className="kslplus-invest-popover-wert">

                                </Col>
                            </>
                        }


                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0)
            {
                items.push(
                    <Row key="4">
                        <Col lg="3">

                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">

                        </Col>


                        <Col lg="3">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 2).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj1, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>


                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0)
            {
                items.push(
                    <Row key="4">
                        <Col lg="3">

                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">

                        </Col>


                        <Col lg="3">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 3).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj2, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>


                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) {
                items.push(
                    <Row key="4">
                        <Col lg="3">

                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">

                        </Col>


                        <Col lg="3">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 4).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj3, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>


                    </Row>
                );
            }
        }
        else if (ga) {
            items.push(
                <Row key="1">
                    <Col lg="7">
                        <div className="kslplus-invest-popover-bezeichnung">Gesamtausgabebedarf:</div>
                    </Col>
                    <Col lg="5" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtbedarf, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>
                </Row>
            );
            items.push(
                <Row key="2">
                    <Col lg="7">
                        <div className="kslplus-invest-popover-bezeichnung">Zuwendungen gesamt:</div>
                    </Col>
                    <Col lg="5" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtzuwendungen, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>
                </Row>
            );
            items.push(
                <Row key="3">
                    <Col lg="7">
                        <div className="kslplus-invest-popover-bezeichnung">Zuwendungsquote:</div>
                    </Col>
                    <Col lg="5" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.gesamtbedarf && invest.investition.gesamtzuwendungen ? invest.investition.gesamtzuwendungen * 100 / invest.investition.gesamtbedarf : 0, 2, 3, '.', ',') + " %"}</div>
                    </Col>
                </Row>
            );
            items.push(
                <Row key="4">
                    <Col lg="7">
                        <div className="kslplus-invest-popover-bezeichnung">Bisher vereinnahmt:</div>
                    </Col>
                    <Col lg="5" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.bisherVereinnahmt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>
                </Row>
            );
            items.push(
                <Row key="5">
                    <Col lg="7">
                        <div className="kslplus-invest-popover-bezeichnung">Bisher verausgabt:</div>
                    </Col >
                    <Col lg="5" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.bisherVerausgabt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>
                </Row>
            );
        }
        else if (ve) {
            items.push(
                <Row key="1">
                    <Col lg="5">
                        <div className="kslplus-invest-popover-bezeichnung">{"Summe der VE für HH " + (this.props.jahr).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veGesamt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>



                </Row>
            );
            items.push(
                <Row key="2">
                    <Col lg="5">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 1).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj1, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            items.push(
                <Row key="3">

                    <Col lg="5">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 2).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj2, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            items.push(
                <Row key="4">
                    <Col lg="5">
                        <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 3).toString() + ":"}</div>
                    </Col>
                    <Col lg="2" className="kslplus-invest-popover-wert">
                        <div>{Utilities.FormatCurrency(invest.investition.veFj3, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </Col>


                </Row>
            );
            if (this.props.settings.doppelhaushalt) {
                items.push(
                    <Row key="4">
                        <Col lg="5">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 4).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.veFj4, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>


                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) {
                items.push(
                    <Row key="1">
                        <Col lg="5">
                            <div className="kslplus-invest-popover-bezeichnung">{"Summe der VE für HH " + (this.props.jahr + 1).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Gesamt, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>



                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) {
                items.push(
                    <Row key="2">
                        <Col lg="5">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 2).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj1, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>
                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) {
                items.push(
                    <Row key="2">
                        <Col lg="5">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 3).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj2, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>
                    </Row>
                );
            }
            if (this.props.settings.doppelhaushalt && (invest.investition?.ve1Gesamt ?? 0) > 0) {
                items.push(
                    <Row key="2">
                        <Col lg="5">
                            <div className="kslplus-invest-popover-bezeichnung">{"davon " + (this.props.jahr + 4).toString() + ":"}</div>
                        </Col>
                        <Col lg="2" className="kslplus-invest-popover-wert">
                            <div>{Utilities.FormatCurrency(invest.investition.ve1Fj3, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        </Col>
                    </Row>
                );
            }

        }
        return items;

    }


    createDataColumn = (field: string, jahr: number, footer: number, footer2: number, id: number, showFooter: boolean = true, showTotal: boolean, text: string = "") => {
        if (text == "") {
            text = "Ergebnis ";
            if (this.props.plantyp === 3 || jahr - this.props.jahr < -1)
                text = "Ergebnis ";
            else if (jahr - this.props.jahr > (this.props.settings.doppelhaushalt ? 1 : 0))
                text = "Finanzplan ";
            else
                text = "Ansatz ";
        }

        return {
            dataField: "ebene",
            text: text + jahr + " (" + this.props.settings.waehrung + ")",
            headerAlign: 'right',
            align: 'right',
            formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbene) => {
                var ebene = row.ebene as { [key: string]: any };

                return (
                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(ebene[field + (row.ausgabe ? "_soll" : "_haben")], this.props.settings.nk, 3, '.', ',')} </div>
                );

            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '18%' };
            },
            style: (colum: any, colIndex: any) => {
                return { width: '18%' };
            },
            footerClasses: (column: any, colIndex: number) => {
                return "kslplus-footer-invest";
            },
            footer: showFooter ? id : undefined,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                if (showTotal) {
                    var sumHaben = 0;
                    var sumSoll = 0;
                    this.state.invests.forEach((row) => {
                        if (row.summenEbene) {
                            var ebene = row.summenEbene as { [key: string]: any };
                            sumSoll += ebene[field + "_soll"];

                            sumHaben += ebene[field + "_haben"];
                        }
                    });
                    return (<div>   <div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')}</div>
                        <div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(footer2, this.props.settings.nk, 3, '.', ',')}</div>
                        <div className="kslplus-tabellen-footer-invest-border"><div className="kslplus-tabellen-footer-invest1">{Utilities.FormatCurrency(sumHaben, this.props.settings.nk, 3, '.', ',')}</div></div>
                        <div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(sumSoll, this.props.settings.nk, 3, '.', ',')} </div></div>);
                }
                if (footer2 !== undefined)
                    return (<div><div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div><div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(footer2, this.props.settings.nk, 3, '.', ',')} </div></div>);

                return (
                    <div className="kslplus-tabellen-footer-invest">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div>
                );
            }
        };
    }

    handleOnExpand = (row: any, isExpand: boolean, rowIndex: number, e: any) => {
        if (isExpand) {
            this.state.expanded.push(row.investition.id);

        } else {
            this.state.expanded = this.state.expanded.filter(x => x !== row.investition.id);
        }
    }

    createDataColumns = (data: KSLPlusAPI.InvestitionsModelDoppik | null | undefined, totalSum: KSLPlusAPI.HaushaltsEbeneDoppik | null | undefined, showTotal: boolean) => {
        var columns = [];

        var id = 1;
        columns.push(
            {
                dataField: 'ebene.bezeichnung',
                text: 'Bezeichnung Maßnahme',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "300px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "300px" };
                },
                footer: id,
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {
                    if (!row.ebene)
                        return null;
                    return (
                        <div>{row.ebene.massnahme && row.ebene.massnahme.length > 0 ? row.ebene.massnahme : row.ebene.bezeichnung}{row.ebene.beschreibung != null && row.ebene.beschreibung.length > 0 ? <div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id={row.ebene.id ? "kslplus-info-text-" + row.ebene.id : ""}>i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target={row.ebene.id ? "kslplus-info-text-" + row.ebene.id : ""}><PopoverBody ><div className="kslplus-tooltip">{row.ebene.beschreibung}</div></PopoverBody > </UncontrolledPopover></div> : null}</div>
                    );
                }
            }

        );
        id++;
        columns.push(
            {
                dataField: 'ebene.produkt',
                text: 'Produkt',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                },
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {
                    if (row.ebene?.produktEbene)
                        return (
                            <div>{row.ebene.produktEbene}</div>
                        );
                    return (
                        <div>{Utilities.Num2Str(row.ebene && row.ebene.produkt !== undefined ? row.ebene.produkt : 0, row.ebene && row.ebene.produktStellen !== undefined ? row.ebene.produktStellen : 0)}</div>
                    );
                },
                footer: id
            }
        );
        id++;
        if (data && (data.ebenen?.findIndex(e => (e.ebene?.konto ?? -1) >= 0) ?? -1) !== -1) {
            columns.push(
                {
                    dataField: 'ebene.konto',
                    text: 'Konto',
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: "100px" };
                    },
                    style: (colum: any, colIndex: any) => {
                        return { width: "100px" };
                    },
                    formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {

                        return (
                            <div>{(row.ebene?.konto ?? -1) < 0 ? "" : Utilities.Num2Str(row.ebene?.konto ?? 0, row.ebene && row.ebene.kontoStellen !== undefined ? row.ebene.kontoStellen : 0)}{row?.ebene?.kontoText && row?.ebene?.kontoText.length > 0 ? <div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id={row.ebene.id ? "kslplus-info-kontotext-" + row.ebene.id : ""}>i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target={row.ebene.id ? "kslplus-info-kontotext-" + row.ebene.id : ""}><PopoverBody ><div className="kslplus-tooltip">{row.ebene.kontoText}</div></PopoverBody > </UncontrolledPopover></div> : null}</div>
                        );
                    },
                    footer: id
                }
            );
            id++;
        }
        columns.push(
            {
                dataField: 'ebene.investNr',
                text: 'Investitions-Nr.',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "120px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "120px" };
                },
                footer: id,
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {

                    if (!row.ebene)
                        return null;
                    return (
                        <div><div className="kslplus-tabellen-bezeichnung">{row.ebene.investNr}</div>
                            {(row.ebene.bestandsKonto || row.ebene.investPosText && row.ebene.investPosText.length > 0 || (row.ebene.investPos != undefined && row.ebene.investPos > -1)) ? <div>< Badge className="kslplus-info-badge " id={row.ebene.id ? "kslplus-info-text-investNr" + row.ebene.id : ""} > i</Badge >
                                <UncontrolledPopover

                                    placement="right"
                                    target={row.ebene.id ? "kslplus-info-text-investNr" + row.ebene.id : ""}
                                    trigger="hover"
                                    className="kslplus-invest-popover"
                                >
                                    <PopoverBody >
                                        <div className="kslplus-invest-popover-investnr">
                                            {row.ebene.bestandsKonto &&
                                                <div>{row.ebene.isErfolgsKonto ? "Erfolgskonto:" : "Bestandskonto:"}</div>
                                            }
                                            {row.ebene.bestandsKonto &&
                                                <div>{row.ebene.bestandsKonto ? row.ebene.bestandsKonto + " - " + row.ebene.bestandsKontoText : ""}</div>
                                            }
                                            {row.ebene.investPos != undefined && row.ebene.investPos > -1 &&
                                                <div>Invest Pos.:</div>
                                            }
                                            {row.ebene.investPos != undefined && row.ebene.investPos > -1 &&
                                                <div>{row.ebene.investPos}</div>
                                            }
                                            {row.ebene.investPosText && row.ebene.investPosText.length > 0 &&
                                                <div> Invest Pos. Text:</div>
                                            }
                                            {row.ebene.investPosText && row.ebene.investPosText.length > 0 &&
                                                <div>{row.ebene.investPosText}</div>
                                            }

                                        </div>

                                    </PopoverBody>
                                </UncontrolledPopover></div> :
                                null}
                        </div>
                    );
                }

            }

        );
        id++;
        columns.push(
            {
                dataField: 'ebene',
                text: 'Einzahlungen/Auszahlungen',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "260px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "260px" };
                },
                footerClasses: (column: any, colIndex: number) => {
                    return "kslplus-footer-invest";
                },
                footerFormatter: (column: any, columnIndex: any) => {

                    if (showTotal && this.state.expanded.length === this.state.invests.length) {
                        var ebenen: KSLPlusAPI.InvestitionsEbeneDoppik[] = [];

                        this.state.invests.forEach((row) => {
                            if (row.ebenen) {
                                row.ebenen.forEach((e) => {
                                    if (!e.ausgabe) {
                                        ebenen.push(e);
                                    }
                                });
                            }
                        });


                        var row = this.state.invests[0];


                        if (row) {
                            return (
                                <div><  div className="kslplus-tabellen-footer-invest">Einzahlungen gesamt</div>
                                    <div className="kslplus-tabellen-footer-invest">Auszahlungen gesamt</div>
                                    <div className="kslplus-tabellen-footer-invest-border">
                                        <div className="kslplus-tabellen-footer-invest1">Einzahlungen über alle Investitionen
                                            {ebenen.length > 0 && <Badge className="kslplus-info-badge " id={"kslplus-invest-einnahemen-hhs"}>i</Badge>}
                                            {ebenen.length > 0 && <UncontrolledPopover
                                                size="lg"
                                                placement="right"
                                                target="kslplus-invest-einnahemen-hhs"
                                                trigger="hover"
                                                className="kslplus-invest-popover">
                                                <Container className="kslplus-invest-popover-block">

                                                    <PopoverBody className="kslplus-invest-popover-body">
                                                        <BootstrapTable bordered={false} keyField='id' data={ebenen} columns={this.createEHHSColumns()} pagination={ebenen.length > 15 ? paginationFactory([{ text: '15', value: 15 }, { text: '20', value: 20 }]) : undefined} />
                                                    </PopoverBody>
                                                </Container>
                                            </UncontrolledPopover>
                                            }
                                        </div>
                                    </div>

                                    <div className="kslplus-tabellen-footer-invest">Auszahlungen über alle Investitionen</div></div>
                            );
                        }
                    }

                    return (
                        <div><div className="kslplus-tabellen-footer-invest">Einzahlungen gesamt </div><div className="kslplus-tabellen-footer-invest">Auszahlungen gesamt</div></div>
                    );
                },
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbene) => {
                    return (
                        <div>{row.ausgabe ? "Auszahlung" : "Einzahlung"}</div>
                    );
                },
                footer: id
            });


        if (this.props.plantyp == 3) {
            id++;            
            if ((this.props.investSettings.startJahrSumJr ?? -4) < -3) {
                columns.push(this.createDataColumn("ergebnisPJM4", this.props.jahr - 4, totalSum && totalSum.ergebnisPJM4_haben !== undefined ? totalSum.ergebnisPJM4_haben : 0, totalSum && totalSum.ergebnisPJM4_soll !== undefined ? totalSum.ergebnisPJM4_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumJr ?? -4) < -2) {
                columns.push(this.createDataColumn("ergebnisPJM3", this.props.jahr - 3, totalSum && totalSum.ergebnisPJM3_haben !== undefined ? totalSum.ergebnisPJM3_haben : 0, totalSum && totalSum.ergebnisPJM3_soll !== undefined ? totalSum.ergebnisPJM3_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumJr ?? -4) < -1) {
                columns.push(this.createDataColumn("ergebnisPJM2", this.props.jahr - 2, totalSum && totalSum.ergebnisPJM2_haben !== undefined ? totalSum.ergebnisPJM2_haben : 0, totalSum && totalSum.ergebnisPJM2_soll !== undefined ? totalSum.ergebnisPJM2_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumJr ?? -4) < 0) {
                columns.push(this.createDataColumn("ergebnisPJM1", this.props.jahr - 1, totalSum && totalSum.ergebnisPJM1_haben !== undefined ? totalSum.ergebnisPJM1_haben : 0, totalSum && totalSum.ergebnisPJM1_soll !== undefined ? totalSum.ergebnisPJM1_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            columns.push(this.createDataColumn("ansatzPJfort", this.props.jahr, totalSum && totalSum.ansatzPJfort_haben !== undefined ? totalSum.ansatzPJfort_haben : 0, totalSum && totalSum.ansatzPJfort_soll !== undefined ? totalSum.ansatzPJfort_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, "Fortgeschriebener Ansatz "));
            id++;
            columns.push(this.createDataColumn("ergebnisPJ", this.props.jahr, totalSum && totalSum.ergebnisPJ_haben !== undefined ? totalSum.ergebnisPJ_haben : 0, totalSum && totalSum.ergebnisPJ_soll !== undefined ? totalSum.ergebnisPJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
            id++;
        }
        else if (this.props.plantyp == 4) {
            id++;
            if ((this.props.investSettings.startJahrSumUh ?? -4) < -3) {
                columns.push(this.createDataColumn("ergebnisPJM4", this.props.jahr - 4, totalSum && totalSum.ergebnisPJM4_haben !== undefined ? totalSum.ergebnisPJM4_haben : 0, totalSum && totalSum.ergebnisPJM4_soll !== undefined ? totalSum.ergebnisPJM4_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumUh ?? -3) < -2) {
                columns.push(this.createDataColumn("ergebnisPJM3", this.props.jahr - 3, totalSum && totalSum.ergebnisPJM3_haben !== undefined ? totalSum.ergebnisPJM3_haben : 0, totalSum && totalSum.ergebnisPJM3_soll !== undefined ? totalSum.ergebnisPJM3_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumUh ?? -2) < -1) {
                columns.push(this.createDataColumn("ergebnisPJM2", this.props.jahr - 2, totalSum && totalSum.ergebnisPJM2_haben !== undefined ? totalSum.ergebnisPJM2_haben : 0, totalSum && totalSum.ergebnisPJM2_soll !== undefined ? totalSum.ergebnisPJM2_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumUh ?? -1) < 0) {
                columns.push(this.createDataColumn("ergebnisPJM1", this.props.jahr - 1, totalSum && totalSum.ergebnisPJM1_haben !== undefined ? totalSum.ergebnisPJM1_haben : 0, totalSum && totalSum.ergebnisPJM1_soll !== undefined ? totalSum.ergebnisPJM1_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, "Ergebnis "));
                id++;
            }
            if (!this.props.settings.keinePrognose && this.props.investSettings.mitVerfuegt) {
                columns.push(this.createDataColumn("verfuegtPJ", this.props.jahr, totalSum && totalSum.verfuegtPJ_haben !== undefined ? totalSum.verfuegtPJ_haben : 0, totalSum && totalSum.verfuegtPJ_soll !== undefined ? totalSum.verfuegtPJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, (this.props.uhconfig?.verfuegtFinName ?? "Geldfluss") + " "));
                id++;
            }
            columns.push(this.createDataColumn("ansatzPJfort", this.props.jahr, totalSum && totalSum.ansatzPJfort_haben !== undefined ? totalSum.ansatzPJfort_haben : 0, totalSum && totalSum.ansatzPJfort_soll !== undefined ? totalSum.ansatzPJfort_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, "Fortgeschriebener Ansatz "));
            id++;
            columns.push(this.createDataColumn("ergebnisPJ", this.props.jahr, totalSum && totalSum.ergebnisPJ_haben !== undefined ? totalSum.ergebnisPJ_haben : 0, totalSum && totalSum.ergebnisPJ_soll !== undefined ? totalSum.ergebnisPJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, this.props.settings.keinePrognose ? ((this.props.uhconfig?.verfuegtFinName ?? "Geldfluss") + " ") : "Prognose manuell "));
            id++;
        }
        else {
            id++;
            if ((this.props.investSettings.startJahrSumHp ?? -2) < -2) {
                columns.push(this.createDataColumn("ergebnisVvvJ", this.props.jahr - 3, totalSum && totalSum.ergebnisVvvJ_haben !== undefined ? totalSum.ergebnisVvvJ_haben : 0, totalSum && totalSum.ergebnisVvvJ_soll !== undefined ? totalSum.ergebnisVvvJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            id++;
            if ((this.props.investSettings.startJahrSumHp ?? -2) < -1) {
                columns.push(this.createDataColumn("ergebnisVvJ", this.props.jahr - 2, totalSum && totalSum.ergebnisVvJ_haben !== undefined ? totalSum.ergebnisVvJ_haben : 0, totalSum && totalSum.ergebnisVvJ_soll !== undefined ? totalSum.ergebnisVvJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.startJahrSumHp ?? -1) < 0) {
                columns.push(this.createDataColumn("ansatzVJ", this.props.jahr - 1, totalSum && totalSum.ansatzVJ_haben !== undefined ? totalSum.ansatzVJ_haben : 0, totalSum && totalSum.ansatzVJ_soll !== undefined ? totalSum.ansatzVJ_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;

                if (this.props.settings.vjErgAnzHp && totalSum?.hasVJErg) {
                    id++;
                    columns.push(this.createDataColumn("ergebnisPJM1", this.props.jahr - 1, totalSum && totalSum.ergebnisPJM1_haben !== undefined ? totalSum.ergebnisPJM1_haben : 0, totalSum && totalSum.ergebnisPJM1_soll !== undefined ? totalSum.ergebnisPJM1_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length, "Ergebnis "));
                }
            }
            columns.push(this.createDataColumn("ansatzPj", this.props.jahr, totalSum && totalSum.ansatzPj_haben !== undefined ? totalSum.ansatzPj_haben : 0, totalSum && totalSum.ansatzPj_soll !== undefined ? totalSum.ansatzPj_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
            id++;
            if ((this.props.investSettings.endJahrSumHp ?? 3) > 0) {
                columns.push(this.createDataColumn("fp1", this.props.jahr + 1, totalSum && totalSum.fp1_haben !== undefined ? totalSum.fp1_haben : 0, totalSum && totalSum.fp1_soll !== undefined ? totalSum.fp1_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.endJahrSumHp ?? 3) > 1) {
                columns.push(this.createDataColumn("fp2", this.props.jahr + 2, totalSum && totalSum.fp2_haben !== undefined ? totalSum.fp2_haben : 0, totalSum && totalSum.fp2_soll !== undefined ? totalSum.fp2_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.endJahrSumHp ?? 3) > 2) {
                columns.push(this.createDataColumn("fp3", this.props.jahr + 3, totalSum && totalSum.fp3_haben !== undefined ? totalSum.fp3_haben : 0, totalSum && totalSum.fp3_soll !== undefined ? totalSum.fp3_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                id++;
            }
            if ((this.props.investSettings.endJahrSumHp ?? 3) > 3) {
                if (this.props.settings.doppelhaushalt) {
                    columns.push(this.createDataColumn("fp4", this.props.jahr + 4, totalSum && totalSum.fp4_haben !== undefined ? totalSum.fp4_haben : 0, totalSum && totalSum.fp4_soll !== undefined ? totalSum.fp4_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
                    id++;
                }
            }
            /*
            columns.push(this.createDataColumn("fp5", this.props.jahr + 5, totalSum && totalSum.fp5_haben !== undefined ? totalSum.fp5_haben : 0, totalSum && totalSum.fp5_soll !== undefined ? totalSum.fp5_soll : 0, id, true, showTotal && this.state.expanded.length === this.state.invests.length));
            id++:
            */
        }
        return columns;
    }


    createEHHSColumns = () => {
        var columns = [];

        var id = 1;
        columns.push(
            {
                dataField: 'ebene.bezeichnung',
                text: 'Bezeichnung Maßnahme',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "250px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "250px" };
                },
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {
                    if (!row.ebene)
                        return null;
                    return (
                        <div>{row.ebene.massnahme && row.ebene.massnahme.length > 0 ? row.ebene.massnahme : row.ebene.bezeichnung}</div>
                    );
                }

            }
        );
        id++;
        columns.push(
            {
                dataField: 'ebene.produkt',
                text: 'Produkt',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                },
                formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {
                    if (row.ebene?.produktEbene)
                        return (
                            <div>{row.ebene.produktEbene}</div>
                        );
                    return (
                        <div>{Utilities.Num2Str(row.ebene && row.ebene.produkt !== undefined ? row.ebene.produkt : 0, row.ebene && row.ebene.produktStellen !== undefined ? row.ebene.produktStellen : 0)}</div>
                    );
                }
            }
        );
        id++;
        if (this.props.invests.findIndex(ie => (ie.ebenen?.findIndex(e => (e?.ebene?.konto ?? -1) >= 0) ?? -1) !== -1) !== -1) {
            columns.push(
                {
                    dataField: 'ebene.konto',
                    text: 'Konto',
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: "100px" };
                    },
                    style: (colum: any, colIndex: any) => {
                        return { width: "100px" };
                    },
                    formatter: (cellContent: string, row: KSLPlusAPI.InvestitionsEbeneDoppik) => {
                        return (
                            <div>{(row.ebene?.konto ?? -1) < 0 ? "" : Utilities.Num2Str(row.ebene && row.ebene.konto !== undefined ? row.ebene.konto : 0, row.ebene && row.ebene.kontoStellen !== undefined ? row.ebene.kontoStellen : 0)}</div>
                        );
                    }
                }
            );
            id++;
        }
        columns.push(
            {
                dataField: 'ebene.investNr',
                text: 'Investitions-Nr.',
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                },
                style: (colum: any, colIndex: any) => {
                    return { width: "100px" };
                }
            }

        );

        id++;
        columns.push(this.createDataColumn("ansatzPj", this.props.jahr, 0, 0, id, false, false));

        return columns;
    }


    expandRowEA = {
        renderer: (row: KSLPlusAPI.InvestitionsModelDoppik) => (
            <BootstrapTable hover={true} bordered={false} keyField='ebene.id' data={row.ebenen ? row.ebenen : []} columns={this.createDataColumns(row, row.summenEbene, row === this.state.invests[this.state.invests.length - 1])} />
        ),
        className: 'kslplus-tabellen-expanded',
        showExpandColumn: true,
        expanded: this.state.expanded,
        onExpand: this.handleOnExpand,
        onExpandAll: (isExpandAll: boolean, rows: KSLPlusAPI.InvestitionsModelDoppik[], e: any) => {
            if (!isExpandAll)
                this.state.expanded = [];
            else
                this.state.expanded = rows.map(row => (row.investition && row.investition.id !== undefined) ? row.investition.id : -1);
        }
    };
    /*
    boolSelectOptions = {
        false: 'nein',
        true: 'ja'
    };*/

    boolSelectOptions = [
        { value: false, label: 'nein' },
        { value: true, label: 'ja' }        
    ];

    resetInvestFilters = () => {
        
        this.getFilters.forEach(fct => fct(""));        
        for (const key in this.filterVals) {            
            this.filterVals[key] = null;
        }
        this.setState({ filterGrenze: 0, filterJahre: 0 });
    }

    getFilterOptions2 = (invests: KSLPlusAPI.InvestitionsModelDoppik[], field: string) => {
        var parts = field.split(".");
        if (parts.length > 1)
            field = parts[1];

        var items: {label: any, value: any}[] = [];
        
        for ( var i = 0; i < invests.length; i++ )
        {
            var invest = invests[i].investition as { [key: string]: any };            
            if ( !items.find( i => i.value === invest[field]) )
                items.push({value: invest[field], label: invest[field]});
        }

        items = items.sort((i1: any, i2: any) => i1?.label?.localeCompare && i1.label.localeCompare(i2.label));

               
        return items;
    }

    getFilterOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[], field: string, selectAll: string = "") => {
        var parts = field.split(".");
        if (parts.length > 1)
            field = parts[1];

        var items: Tree.TreeNode[] = [];

        for (var i = 0; i < invests.length; i++) {
            var invest = invests[i].investition as { [key: string]: any };

            var item: Tree.TreeNode = { label: invest[field], value: invest[field], tagLabel: invest[field] }
            //if (this.filterVals[field].some(d => d === invest[field]))
                item.checked = this.filterVals[field]?.some((d: any) => d === invest[field]);
            if (!items.find(i => i.value === invest[field]))
                items.push(item);
        }

        items = items.sort((i1: any, i2: any) => i1?.label?.localeCompare && i1.label.localeCompare(i2.label));
        if (selectAll !== "")
            items.unshift({ label: selectAll, value: "", tagLabel: null })

        return items;
    }

    getProduktOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[]) => {
        //var items: {label: any, value: any}[] = [];
        var items: Tree.TreeNode[] = [];
        for ( var i = 0; i < invests.length; i++ )
        {            
            var se = invests[i].summenEbene;
            if ( !se || !se.produkt)
                continue;
            if (se.produktEbene) {
                if (!items.find(inv => se && inv.value === se.produktEbene))
                    items.push({ value: se.produktEbene, label: se.produktEbene + " - " + se.produktText });
            }
            else {
                if (!items.find(inv => se && se.produkt && inv.value === se.produkt?.toString()))
                    items.push({ value: se.produkt?.toString(), label: Utilities.Num2Str(se.produkt !== undefined ? se.produkt : 0, se.produktStellen !== undefined ? se.produktStellen : 0) + " - " + se.produktText });
            }
        }

        items = items.sort((i1: any, i2: any) => i1.label && i1.label.localeCompare(i2.label));

        return items;
    }

    getKontenOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[]) => {
        //var items: { label: any, value: any }[] = [];        
        var items: Tree.TreeNode[] = [];
        for (var i = 0; i < invests.length; i++) {
            var ebenen = invests[i].ebenen;
            if (!ebenen)
                continue;

            ebenen.forEach(e => {
                if (e.ausgabe) {
                    if (!items.some(k => k.value === (e.ebene?.konto ?? 0).toString())) {
                        items.push({ value: (e.ebene?.konto ?? 0).toString(), label: Utilities.Num2Str(e.ebene?.konto ?? 0, e.ebene?.kontoStellen ?? 0) + " - " + e.ebene?.kontoText });
                    }
                }
            });
        }

        items = items.sort((i1: any, i2: any) => i1.label && i1.label.localeCompare(i2.label));

        return items;
    }

    getEbenenOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[]) => {
        //var items: { label: any, value: any }[] = [];        
        var items: Tree.TreeNode[] = [];
        for (var i = 0; i < invests.length; i++) {
            var summenEbene = invests[i].summenEbene;
            if (!summenEbene)
                continue;

            summenEbene.ebenen?.forEach(e => {
                if (!items.some(k => k.value === e)) {
                    items.push({ value: e, label: e });
                }                
            });
        }

        items = items.sort((i1: any, i2: any) => i1.label && i1.label.localeCompare(i2.label));

        return items;
    }

    getInvestNrOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[]) => {
        var items: { label: any, value: any }[] = [];

        for (var i = 0; i < invests.length; i++) {
            var se = invests[i].summenEbene;
            if (!se || !se.investNr)
                continue;
            if (!items.find(inv => se && se.investNr && inv.value === se.investNr))
                items.push({ value: se.investNr, label: se.investNr });
        }

        items = items.sort((i1: any, i2: any) => i1.label && i1.label.localeCompare(i2.label));
        
        return items;
    }

    getTeilhaushaltOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[]) => {
        var items: { label: any, value: any }[] = [];

        for (var i = 0; i < invests.length; i++) {
            var se = invests[i].summenEbene;
            if (!se || !se.teilhaushalt)
                continue;
            if (!items.find(inv => se && se.teilhaushalt && inv.value === se.teilhaushalt))
                items.push({ value: se.teilhaushalt, label: se.teilhaushalt });
        }

        items = items.sort((i1: any, i2: any) => i1.label && i1.label.localeCompare(i2.label));

        return items;
    }

    getInvestitionsartOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[], arten: KSLPlusAPI.Investitionsarten[]) => {
        var items: {label: any, value: any}[] = [];
        
        for ( var i = 0; i < arten.length; i++ )
        {
            if ( invests.find(inv => inv.investition && inv.investition.investitionsart && inv.investition.investitionsart == arten[i].id) )
            {

                if ( !items.find( it => it.value === arten[i].bezeichnung) )
                    items.push({value: arten[i].id, label: arten[i].bezeichnung});
            }
        }
               
        return items;
    }

    getVermoegensartOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[], arten: KSLPlusAPI.VermoegensartDoppisch[]) => {
        var items: {label: any, value: any}[] = [];
        
        for ( var i = 0; i < arten.length; i++ )
        {
            if ( invests.find(inv => inv.investition && inv.investition.vermoegensart && inv.investition.vermoegensart == arten[i].id) )
            {

                if ( !items.find( it => it.value === arten[i].bezeichnung) )
                    items.push({value: arten[i].id, label: arten[i].bezeichnung});
            }
        }
               
        return items;
    }

    getVermoegenstypOptions = (invests: KSLPlusAPI.InvestitionsModelDoppik[], arten: KSLPlusAPI.VermoegensartDoppisch[]) => {
        var items: {label: any, value: any}[] = [];
        
        for ( var i = 0; i < arten.length; i++ )
        {
            var va = arten[i];            
            if ( !va.vermoegenstypen )
                continue;

            for (var j = 0; j < va.vermoegenstypen.length; j++ )
            {   
                if (invests.find(inv => va.vermoegenstypen && inv.investition && inv.investition.vermoegensart && inv.investition.vermoegenstyp == va.vermoegenstypen[j].id) )
                {

                    if (!items.find(it => va.vermoegenstypen && it.value === va.vermoegenstypen[j].bezeichnung) )
                        items.push({value: va.vermoegenstypen[j].id, label: va.vermoegenstypen[j].bezeichnung});
                }
            }
        }
               
        return items;
    }

    readInvestitionsarten = () => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHousholdAdmin_Client(api);


        client.investitionsarten("").then(ias => {            
            this.investitionsarten = ias;
            this.readVermoegensarten();
            
        }).catch(Reason => {
            this.investitionsarten = [];
        });
    }

    readVermoegensarten = () => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHousholdDoppikAdmin_Client(api);


        client.vermoegensarten(this.props.kunde, "").then(vas => {
            this.vermoegensarten = vas;              
            // investition auf state übernehmen nachdem alles geladen wurde
            this.setState({ invests: this.props.invests });            
            this.resetInvestFilters();
        }).catch(Reason => {
            this.vermoegensarten = [];
        });
    }
   
    filterInvestitionen = () => {
        return this.state.invests.filter(i => {
            var sum = 0;
            if (i.ebenen) {
                i.ebenen.forEach(e => {

                    if (this.props.plantyp === 3) {
                        sum += e.ebene?.ergebnisPJ_soll ?? 0;
                    }
                    else if (this.props.plantyp === 4) {
                        sum += e.ebene?.ansatzPJfort_soll ?? 0;
                    }
                    else {
                        sum += e.ebene?.ansatzPj_soll ?? 0;
                    }
                    if (this.props.plantyp > 2) {
                        if (this.state.filterJahre > 0)
                            sum += e.ebene?.ergebnisPJM1_soll ?? 0;
                        if (this.state.filterJahre > 1)
                            sum += e.ebene?.ergebnisPJM2_soll ?? 0;
                        if (this.state.filterJahre > 2)
                            sum += e.ebene?.ergebnisPJM3_soll ?? 0;
                        if (this.state.filterJahre > 3)
                            sum += e.ebene?.ergebnisPJM4_soll ?? 0;
                    }
                    else {
                        if (this.state.filterJahre > 0)
                            sum += e.ebene?.fp1_soll ?? 0;
                        if (this.state.filterJahre > 1)
                            sum += e.ebene?.fp2_soll ?? 0;
                        if (this.state.filterJahre > 2)
                            sum += e.ebene?.fp3_soll ?? 0;
                        if (this.state.filterJahre > 3)
                            sum += e.ebene?.fp4_soll ?? 0;
                    }
                });
            }
            return sum >= (this.state.filterGrenze ?? 0);

        });
    }


    
    render() {    
        if (this.state.invests != this.props.invests )
            return <div className="kslplus-haushaltstab-wrapper-invest" />;
        return (                                    
            <div className="kslplus-haushaltstab-wrapper-invest">
                {this.props.plantyp > 2 ?
                    <div className="form-group  kslplus-input-row">
                        <label className="kslplus-input-row" htmlFor="kslplus-invest-sumjahre">Investitionen nur anzeigen wenn die Summe der Aufwendungen/Auszahlungen im Rechnungsjahr und der </label>                        
                        {this.props.plantyp === 3 ?
                            <select id="kslplus-invest-sumjahre" className="form-select kslplus-input" value={this.state.filterJahre} onChange={(e) => this.setState({ filterJahre: +e.target?.value })} >
                                <option value="0">0</option>
                                {(this.props.investSettings.startJahrSumJr ?? -4) < 0 &&
                                    <option value="1">1</option>}
                                {(this.props.investSettings.startJahrSumJr ?? -4) < -1 &&
                                    <option value="2">2</option>}
                                {(this.props.investSettings.startJahrSumJr ?? -4) < -2 &&
                                    <option value="3">3</option>}
                                {(this.props.investSettings.startJahrSumJr ?? -4) < -3 &&
                                    <option value="4">4</option>}
                            </select>
                            :
                            <select id="kslplus-invest-sumjahre" className="form-select kslplus-input" value={this.state.filterJahre} onChange={(e) => this.setState({ filterJahre: +e.target?.value })} >
                                <option value="0">0</option>
                                {(this.props.investSettings.startJahrSumUh ?? -4) < 0 &&
                                    <option value="1">1</option>}
                                {(this.props.investSettings.startJahrSumUh ?? -4) < -1 &&
                                    <option value="2">2</option>}
                                {(this.props.investSettings.startJahrSumUh ?? -4) < -2 &&
                                    <option value="3">3</option>}
                                {(this.props.investSettings.startJahrSumUh ?? -4) < -3 &&
                                    <option value="4">4</option>}
                            </select>
                        }
                        <label className="kslplus-input-row" htmlFor="kslplus-invest-folgejahre"> Vorjahre mindestens </label>

                        <NumberFormat
                            id="kslplus-invest-folgejahre"
                            className="kslplus-input-value"
                            defaultValue={this.state.filterGrenze}
                            decimalSeparator=","
                            displayType="input"
                            prefix=""
                            type="text"
                            thousandSeparator="."
                            allowNegative={true}
                            value={this.state.filterGrenze}
                            onValueChange={(value: any, sourceInfo: any) => {
                                this.setState({ filterGrenze: value.floatValue });
                            }}
                        />
                        <label className="kslplus-input-row"> {this.props.settings.waehrung} beträgt.</label>
                    </div> :
                    <div className="form-group  kslplus-input-row">
                        <label className="kslplus-input-row" htmlFor="kslplus-invest-sumjahre">Investitionen nur anzeigen wenn die Summe der Aufwendungen/Auszahlungen im Planjahr und der </label>
                        <select id="kslplus-invest-sumjahre"  className="form-select kslplus-input" value={this.state.filterJahre} onChange={(e) => this.setState({ filterJahre: +e.target?.value })} >
                            <option value="0">0</option>
                            {(this.props.investSettings.endJahrSumHp ?? 3) > 0 &&
                                <option value="1">1</option>}
                            {(this.props.investSettings.endJahrSumHp ?? 3) > 1 &&
                                <option value="2">2</option>}
                            {(this.props.investSettings.endJahrSumHp ?? 3) > 2 &&
                                <option value="3">3</option>}
                            {(this.props.investSettings.endJahrSumHp ?? 3) > 3 && this.props.settings.doppelhaushalt &&
                                <option value="4">4</option>}
                           
                        </select>
                        <label className="kslplus-input-row" htmlFor="kslplus-invest-folgejahre"> Folgejahre mindestens </label>
                        <NumberFormat
                            id="kslplus-invest-folgejahre"
                            className="kslplus-input-value"
                            defaultValue={this.state.filterGrenze}
                            decimalSeparator=","
                            displayType="input"
                            prefix=""
                            type="text"
                            thousandSeparator="."
                            allowNegative={true}
                            value={this.state.filterGrenze}
                            onValueChange={(value: any, sourceInfo: any) => {
                                this.setState({ filterGrenze: value.floatValue } );
                            }}
                        />
                        <label className="kslplus-input-row"> {this.props.settings.waehrung} beträgt.</label>
                    </div>
                }
                <div className="kslplus-content-invest">
                    <button aria-label="Filter zurücksetzen" id="kslbutton-clear-filters" className={"kslplus-invest-delete-filteres"} onClick={() => {this.resetInvestFilters()}}>                                                                              
                        <img src= {env.REACT_APP_PUBLIC_URL + "4115230_cancel_close_delete_icon.png"} alt="Filter zurücksetzen" />                                                    
                    </button>     
                    <UncontrolledTooltip delay={{show:1000, hide: 0}} className="kslplus-tooltip" placement="right" target="kslbutton-clear-filters">Filter zurücksetzen</UncontrolledTooltip>                                           
                    <BootstrapTable keyField='investition.id' data={this.filterInvestitionen()} columns={this.createColumns(this.state.invests, this.props.investSettings.spalten ? this.props.investSettings.spalten : "")} expandRow={this.props.settings.hhStellenOeffentlich ? this.expandRowEA : undefined} filter={ filterFactory() } filterPosition="top" bordered={ false }/>
                </div>                
            </div>
                                            
        );
    }
}